// Copyright (c) billwerk GmbH. All rights reserved.
// 'use strict';
var SubscriptionJS = (function (subscriptionJs) {
    // the base url (with trailing slash) for this instance. The string will be
    // replaced by the itero backend before minify the JS file with the actual
    // instance's base URL automatically.

    subscriptionJs.apiUrl = "https://app.billwerk.com/api/v1/";
    subscriptionJs.selfServiceUrl = "https://selfservice.billwerk.com/";//"[[billwerkServerUrl]]";

    // TODO: VAT ID validation
    var VAT_ID_REGEX = {
        "AT": /^ATU[A-Z0-9]{8,8}$/,
        "BE": /^BE[0-9]{10,10}$|^BE[0]{1,1}[0-9]{9,9}$/,
        "BG": /^BG[0-9]{9,10}$/,
        "CH": /^CHE-?[0-9]{3,3}.?[0-9]{3,3}.?[0-9]{3,3}$/,
        "CY": /^CY[0-9]{8,8}[A-Z]{1,1}$/,
        "CZ": /^CZ[0-9]{8,10}$/,
        "DE": /^DE[0-9]{9,9}$/,
        "DK": /^DK[0-9]{8,8}$/,
        "EE": /^EE[0-9]{9,9}$/,
        "EL": /^EL[0-9]{9,9}$/,
        "ES": /^ES[A-Z0-9]{1,1}[0-9]{7,7}[A-Z0-9]{1,1}$/,
        "FI": /^FI[0-9]{8,8}$/,
        "FR": /^FR[A-Z0-9]{2,2}[0-9]{9,9}$/,
        "GB": /^GB[0-9]{9,9}$|^GB[0-9]{12,12}$|^GBGD[0-9]{3,3}$|^GBHA[0-9]{3,3}$/,
        "XI": /^XI[0-9]{9,9}$|^XI[0-9]{12,12}$|^XIGD[0-9]{3,3}$|^XIHA[0-9]{3,3}$/,
        "HR": /^HR[0-9]{11,11}$/,
        "HU": /^HU[0-9]{8,8}$/,
        "IE": /^IE[0-9]{1,1}[A-Z0-9]{1,1}[0-9]{5,5}[A-Z]{1,1}$|^IE[0-9]{7,7}[A-W]{1,1}[A-I]{1,1}$/,
        "IT": /^IT[0-9]{11,11}$/,
        "LT": /^LT[0-9]{9,9}$|^LT[0-9]{12,12}$/,
        "LU": /^LU[0-9]{8,8}$/,
        "LV": /^LV[0-9]{11,11}$/,
        "MT": /^MT[0-9]{8,8}$/,
        "NL": /^NL[A-Z0-9]{9,9}B[A-Z0-9]{2,2}$/,
        "PL": /^PL[0-9]{10,10}$/, "PT": /^PT[0-9]{9,9}$/,
        "RO": /^RO[1-9]{1,1}[0-9]{1,9}$/,
        "SE": /^SE[0-9]{12,12}$/,
        "SI": /^SI[0-9]{8,8}$/,
        "SK": /^SK[0-9]{10,10}$/
    };

    var NATIONAL_ID_NUMBER_REGEX = {
        "DK": /^\d{6}-\d{4}$/,
        "SE": /^\d{8}-\d{4}$/,
    };

    var PAYONE_ERROR_MAP = [
        [[900, 901, 904, 907, 990], "PspServerError"],
        [[971], "Timeouts"],
        [[924, 925, 926, 927, 930], "InvalidConfiguration"],
        [[14, 880, 984, 895, 896, 897, 937], "InvalidPaymentData"],
        [[970], "Aborted"],
        [[1, 91, 902, 903, 991], "AcquirerServerError"],
        [[2, 5], "AuthorizationRejected"],
        [[951], "RateLimit"],
        [[12, 911, 912, 913], "InvalidTransaction"],
        [[13, 891, 906, 908, 917, 918, 919, 920], "AmountLimitExceeded"],
        [[923, 931, 932, 933, 934], "InvalidPaymentMethod"],
        [[1076, 31], "InvalidCardType"],
        [[1073, 1075, 1078, 56, 877, 872], "InvalidCardNumber"],
        [[1077, 33], "InvalidExpirationDate"],
        [[1079, 7, 879], "InvalidCardCvc"],
        [[894], "InvalidCardHolder"],
        [[916, 935, 944, 945, 962], "InvalidAmount"],
        [[910], "InvalidCurrency"],
        [[1083, 883], "InvalidAccountNumber"],
        [[1080], "InvalidAccountHolder"],
        [[1081, 1082, 1084, 1085, 1086, 884], "InvalidBankCode"],
        [[1087, 887], "InvalidBic"],
        [[1088, 888], "InvalidIban"],
        [[889, 892, 893], "InvalidCountry"],
        [[881, 882, 886, 890, 34, 4, 62], "BearerRejected"]
    ];

    var WIRECARD_ERROR_MAP = [
        [["30003", "30004", "30005", "30006", "30008", "30009", "30011"], "PspServerError"],
        [["30002"], "InvalidConfiguration"],
        [["20012", "20013", "20014", "20015", "20026", "20027", "20033", "20038", "20039"], "InvalidPaymentData"],
        [["20021"], "Aborted"],
        [["20010"], "AcquirerServerError"],
        [["20006", "20009"], "AuthorizationRejected"],
        [["20004"], "BearerExpired"],
        [["20000", "20001", "20002", "20003", "20004", "20016", "20017", "20018", "20032"], "BearerRejected"],
        [["xx034", "20008", "20011", "20028", "20034"], "InvalidTransaction"],
        [["xx201", "xx202", "xx204", "xx205"], "AmountLimitExceeded"],
        [["xx051", "30001"], "InvalidPaymentMethod"],
        [["xx115"], "InvalidCardNumber"],
        [["xx116"], "InvalidExpirationDate"],
        [["xx117"], "InvalidCardCvc"],
        [["xx151"], "InvalidCardHolder"],
        [["xx017"], "InvalidAmount"],
        [["xx019"], "InvalidCurrency"],
        [["xx119"], "InvalidAccountNumber"],
        [["xx142"], "InvalidAccountHolder"],
        [["xx120"], "InvalidBankCode"],
        [["xx152"], "InvalidIban"],
        [["xx132"], "InvalidCountry"]
    ];

    var STRIPE_ERROR_MAP = [
        ["invalid_number", "InvalidCardNumber"],
        ["invalid_expiry_month", "InvalidExpirationDate"],
        ["invalid_expiry_year", "InvalidExpirationDate"],
        ["invalid_cvc", "InvalidCardCvc"],
        ["incorrect_number", "InvalidCardNumber"],
        ["expired_card", "InvalidExpirationDate"],
        ["incorrect_cvc", "InvalidCardCvc"],
        ["incorrect_zip", "UnmappedError"],
        ["card_declined", "InvalidPaymentData"],
        ["processing_error", "PspServerError"]
    ];

    var FAKE_ERROR_MAP = {
        "invalid_number": "InvalidCardNumber",
        "invalid_bic": "InvalidBic",
        "invalid_iban": "InvalidIban",
        "invalid_cvc": "InvalidCardCvc",
        "invalid_expiry_month": "InvalidExpirationDate",
        "invalid_expiry_year": "InvalidExpirationDate",
        "expired_card": "InvalidExpirationDate",
        "invalid_card_holder": "InvalidCardHolder",
        "invalid_acount_holder": "InvalidAccountHolder",
        "processing_error": "PspServerError"
    };

    // Subscription's exception class
    function SubscriptionError(message) {
        this.message = message || "";
        this.stack = new Error().stack;
    }
    SubscriptionError.prototype = new Error();
    SubscriptionError.prototype.name = "IteroError";

    var isElementObj = function (obj) {
        if (!obj)
            return false;

        if (typeof obj !== 'object')
            return false;

        if (!obj.tetherPaymentInformation)
            return false;

        if (typeof obj.tetherPaymentInformation !== 'function')
            return false;

        return true;
    };

    // IE8 compatibility implementation
    if (!Object.keys) {
        Object.keys = (function () {
            'use strict';
            var hasOwnProperty = Object.prototype.hasOwnProperty,
                hasDontEnumBug = !{ toString: null }.propertyIsEnumerable('toString'),
                dontEnums = [
                    'toString',
                    'toLocaleString',
                    'valueOf',
                    'hasOwnProperty',
                    'isPrototypeOf',
                    'propertyIsEnumerable',
                    'constructor'
                ],
                dontEnumsLength = dontEnums.length;

            return function (obj) {
                if (typeof obj !== 'object' && (typeof obj !== 'function')) {
                    throw new TypeError('Object.keys called on non-object');
                }

                var result = [], prop, i;
                for (prop in obj) {
                    if (hasOwnProperty.call(obj, prop)) {
                        result.push(prop);
                    }
                }

                if (hasDontEnumBug) {
                    for (i = 0; i < dontEnumsLength; i++) {
                        if (hasOwnProperty.call(obj, dontEnums[i])) {
                            result.push(dontEnums[i]);
                        }
                    }
                }
                return result;
            };
        }());
    }

    subscriptionJs.BEARER =
        {
            PayOne: {
                Debit: "Debit:PayOne",
                CreditCard: "CreditCard:PayOne",
                OnAccount: "OnAccount:PayOne"
            },
            PayPal: {
                BlackLabel: "BlackLabel:PayPal",
                PayPal: "PayPal"
            },
            None: {
                None: "None:None"
            },
            FakePSP: {
                Debit: "Debit:FakePSP",
                CreditCard: "CreditCard:FakePSP",
                BlackLabel: "BlackLabel:FakePSP",
                FakePSP: "FakePSP"
            },
            InvoicePayment: {
                BlackLabel: "BlackLabel:InvoicePayment",
                InvoicePayment: "InvoicePayment"
            },
            Wirecard: {
                Debit: "Debit:Wirecard",
                CreditCard: "CreditCard:Wirecard"
            },
            Stripe: {
                Debit: "Debit:Stripe",
                CreditCard: "CreditCard:Stripe"
            },
            Heidelpay: {   //todo: remove after merchants migration to unzer keys
                Debit: "Debit:Heidelpay",
                CreditCard: "CreditCard:Heidelpay"
            },
            Unzer: {
                Debit: "Debit:Unzer",
                CreditCard: "CreditCard:Unzer"
            },
            SlimPay: {
                Debit: "Debit:SlimPay",
                CreditCard: "CreditCard:SlimPay"
            },
            GoCardless: {
                Debit: "Debit:GoCardless",
                Betalingsservice: "Betalingsservice:GoCardless"
            },
            WirecardElastic: {
                Debit: "Debit:WirecardElastic",
                CreditCard: "CreditCard:WirecardElastic"
            },
            Adyen: {
                Debit: "Debit:Adyen",
                CreditCard: "CreditCard:Adyen",
                iDEAL:"iDEAL:Adyen"
            },
            Worldline: {
                CreditCard: "CreditCard:Worldline"
            },
            Worldpay: {
                Debit: "Debit:Worldpay",
                CreditCard: "CreditCard:Worldpay"
            },
            MobilePay: {
                MobilePay: "MobilePay",
                BlackLabel: "BlackLabel:MobilePay"
            },
            NetsEasy: {
                CreditCard: "CreditCard:NetsEasy"
            },
            PayEx: {
                CreditCard: "CreditCard:PayEx"
            },
            PayExInvoiceService:{
                Autogiro: "Autogiro:PayExInvoiceService",
                Avtalegiro:"Avtalegiro:PayExInvoiceService",
                Betalingsservice:"Betalingsservice:PayExInvoiceService"
            },
            FarPay: {
                Betalingsservice: "Betalingsservice:FarPay"
            },
            Mollie: {
                Debit: "Debit:Mollie",
                CreditCard: "CreditCard:Mollie"
            },
            AmazonPay: {
                AmazonPay: "AmazonPay",
                BlackLabel: "BlackLabel:AmazonPay"
            },
            Reepay: {
                CreditCard: "CreditCard:Reepay"
            },
            SepaXml: {
                Debit: "Debit:SepaXml",
            }
        };

    //payment form element communication const
    subscriptionJs.IFRAME_MSG_TYPES = {
        //messages sent to iframe
        IN: {
            PaymentSettings: "paymentSettings",
            PayerDataChanged: "payerDataChanged",
            TetherPaymentInformation: "tetherPaymentInformation",
            //Tether Payment Info without server call or redirect
            TetherPaymentInformation2: "tetherPaymentInformation2",
            FinalTetherPaymentInformation: "finalTetherPaymentInformation"
        },
        //messages sent from iframe
        OUT: {
            Resize: "resize",
            ConfigLoaded: "configLoaded",
            PaymentReady: "paymentReady",
            TetheredPaymentData: "tetheredPaymentData",
            FinalTetheredPaymentData: "finalTetheredPaymentData",
            Error: "error",
            UnloadPaymentForm: "unloadPaymentForm",
            ProcessPaymentOutsideTheIFrame: "processPaymentOutsideTheIFrame"
        }
    };

    var isTetheredPaymentData;
    subscriptionJs.Portal = function (customerToken) {
        if (!customerToken)
            throw new SubscriptionError("ArgumentMissing: customerToken");

        this.upgradePreview = function () { throw new SubscriptionError("NotImplemented"); };

        this.upgradePayInteractive = function (iteroJSPayment, secretPaymentData, order, success, error) {
            if (!iteroJSPayment && !isElementObj(secretPaymentData) && !isTetheredPaymentData(secretPaymentData))
                throw new SubscriptionError("ArgumentMissing: iteroJSPayment");
            if (!secretPaymentData)
                throw new SubscriptionError("ArgumentMissing: secretPaymentData");
            else if (iteroJSPayment && isElementObj(secretPaymentData))
                throw new SubscriptionError("ArgumentConflict: iteroJSPayment, secretPaymentData");
            if (!order)
                throw new SubscriptionError("ArgumentMissing: order");
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");
            if (!order.OrderId || !order.Currency)
                throw new SubscriptionError("ArgumentInvalid: order is not an order. Currency or OrderId missing");

            var paymentTotal = order.GrossTotal <= 0 ? null : order.GrossTotal;
            if (isElementObj(secretPaymentData))
                iteroJSPayment = secretPaymentData;
            var successFn = function (tetheredPaymentData) {
                var dto = { payOrderType: "Interactive", paymentData: tetheredPaymentData, orderId: order.OrderId };
                post(subscriptionJs.apiUrl + "CustomerSelfService/PayUpgradeOrder?token=" + customerToken,
                    dto,
                    function (data) {
                        if (iteroJSPayment !== null && iteroJSPayment.isFinalTetherPaymentInformationCallRequired(secretPaymentData))
                            iteroJSPayment.finalTetherPaymentInformation(data,
                                data.GrossTotal === 0 ? null : data.GrossTotal,
                                order.Currency,
                                secretPaymentData,
                                function (data) {
                                    callAsync(success, data);
                                },
                                error);
                        else
                            callAsync(success, data);
                    },
                    error);
            };
            if (!iteroJSPayment)
                successFn(secretPaymentData);
            else
                iteroJSPayment.tetherPaymentInformation(paymentTotal, order.Currency, secretPaymentData,
                    successFn,
                    function (errorData) {
                        callAsync(error, errorData);
                    });
        };

        this.upgradePaySync = function (orderId, success, error) {
            if (!orderId)
                throw new SubscriptionError("ArgumentMissing: orderId");
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");
            var dto = { orderId: orderId, payOrderType: "Synchronous" };
            post(subscriptionJs.apiUrl + "CustomerSelfService/PayUpgradeOrder?token=" + customerToken, dto, success, error);
        };

        this.invoicePdfDownloadUrl = function (invoice) {
            if (!invoice)
                throw new SubscriptionError("ArgumentMissing: invoice");
            var idString;
            if (typeof invoice === "object" && invoice.Id)
                idString = invoice.Id;
            else if (typeof invoice === "string")
                idString = invoice;
            else
                throw new SubscriptionError("Invalid parameter invoice, must be an invoice object or a string!");
            return subscriptionJs.apiUrl + "CustomerSelfService/Download/" + idString + "?token=" + customerToken;
        };

        this.contractDetails = function (success, error) {
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");
            get(subscriptionJs.apiUrl + "CustomerSelfService/ContractDetails", { token: customerToken }, success, error);
        };

        this.contractCancel = function (success, error) {
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");
            rest(subscriptionJs.apiUrl + "CustomerSelfService?token=" + customerToken, "DELETE", {}, success, error);
        };

        this.customerChange = function (customerData, success, error) {
            if (!customerData)
                throw new SubscriptionError("ArgumentMissing: customerData");
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");

            customerData = sanitizeCustomerData(customerData);
            if (!validateCustomerData(customerData, error))
                return;

            patch(subscriptionJs.apiUrl + "CustomerSelfService/CustomerData?token=" + customerToken, customerData, success, error);
        };

        this.contractCustomFieldsChange = function (contractCustomFields, success, error) {
            if (!contractCustomFields)
                throw new SubscriptionError("ArgumentMissing: contractCustomFields");
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");

            //contractCustomFields = sanitizeCustomFields(contractCustomFields);
            put(subscriptionJs.apiUrl + "CustomerSelfService/ContractCustomFields?token=" + customerToken, contractCustomFields, success, error);
        };

        this.getRisk = function (success, error) {
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");
            get(subscriptionJs.apiUrl + "CustomerSelfService/Risk?token=" + customerToken, {}, success, error);
        };

        var changePaymentMethodLocked = false;
        this.paymentChange = function (iteroJSPayment, secretPaymentData, success, error, contractCurrency) {
            if (!iteroJSPayment && !isElementObj(secretPaymentData) && !isTetheredPaymentData(secretPaymentData))
                throw new SubscriptionError("ArgumentMissing: iteroJSPayment");
            if (!secretPaymentData)
                throw new SubscriptionError("ArgumentMissing: secretPaymentData");
            else if (iteroJSPayment && isElementObj(secretPaymentData))
                throw new SubscriptionError("ArgumentConflict: iteroJSPayment, secretPaymentData");
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");
            if (changePaymentMethodLocked)
                throw new SubscriptionError("changePaymentMethod() is already running!");

            changePaymentMethodLocked = true;
            var errorFn = function (errorData) {
                changePaymentMethodLocked = false;
                callAsync(error, errorData);
            };
            if (isElementObj(secretPaymentData))
                iteroJSPayment = secretPaymentData;
            var successGetTransactionValues = function (transactionValues) {
                var total = null;
                var currency = transactionValues.Currency;
                var successFn = function (tetheredPaymentData) {
                    // the 'tethered payment data' is chained to the specific PSP
                    post(
                        subscriptionJs.apiUrl + "CustomerSelfService/PaymentMethod?token=" + customerToken,
                        tetheredPaymentData,
                        function (data) {
                            if (iteroJSPayment !== null && iteroJSPayment.isFinalTetherPaymentInformationCallRequired(secretPaymentData))
                                iteroJSPayment.finalTetherPaymentInformation(data,
                                    total,
                                    currency,
                                    secretPaymentData,
                                    function (data) {
                                        changePaymentMethodLocked = false;
                                        callAsync(success, data);
                                    },
                                    errorFn);
                            else {
                                changePaymentMethodLocked = false;
                                callAsync(success, data);
                            }
                        },
                        errorFn);
                };
                if (iteroJSPayment === null)
                    successFn(secretPaymentData);
                else
                    iteroJSPayment.tetherPaymentInformation(total, currency, secretPaymentData, successFn, errorFn);
            };

            if (contractCurrency)
                successGetTransactionValues({ Currency: contractCurrency });
            else
                // We need to know the amount for the transaction, which is either the current contract balance, or
                // a preauth amount in case the balance is zero or negative, hence we query TransactionValues
                get(subscriptionJs.apiUrl + "CustomerSelfService/TransactionValues?txToken=abc&token=" + customerToken, {}, successGetTransactionValues, errorFn);
        };
    }; // end of IteroJS.Portal

    subscriptionJs.Signup = function () {
        var self = this;
        var subscriptionInProgress = false;

        this.paySignupInteractive = function (iteroJSPayment, secretPaymentData, order, success, error) {
            if (subscriptionInProgress) // If in progress this was already called, so we return at this point
                return;

            if (!iteroJSPayment && !isElementObj(secretPaymentData) && !isTetheredPaymentData(secretPaymentData))
                throw new SubscriptionError("ArgumentMissing: iteroJSPayment");
            if (!secretPaymentData)
                throw new SubscriptionError("ArgumentMissing: secretPaymentData");
            else if (iteroJSPayment && isElementObj(secretPaymentData))
                throw new SubscriptionError("ArgumentConflict: iteroJSPayment, secretPaymentData");
            if (!order)
                throw new SubscriptionError("ArgumentMissing: order");
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");
            if (!order.OrderId || !order.Currency)
                throw new SubscriptionError("ArgumentInvalid: order is not an order. Currency or OrderId missing");

            if (isElementObj(secretPaymentData))
                iteroJSPayment = secretPaymentData;

            var paymentTotal = order.GrossTotal === 0 ? null : order.GrossTotal;

            subscriptionInProgress = true;
            try {
                var errorFn = function (errorData) {
                    subscriptionInProgress = false;
                    callAsync(error, errorData);
                };
                var successFn = function (tetheredPaymentData) {
                    var dto = { payOrderType: "Interactive", paymentData: tetheredPaymentData, orderId: order.OrderId };
                    post(subscriptionJs.apiUrl + "CustomerSelfService/signup/pay", dto,
                        function (data) {
                            if (iteroJSPayment !== null && iteroJSPayment.isFinalTetherPaymentInformationCallRequired(secretPaymentData))
                                iteroJSPayment.finalTetherPaymentInformation(data,
                                    paymentTotal,
                                    order.Currency,
                                    secretPaymentData,
                                    function (data) {
                                        subscriptionInProgress = false;
                                        callAsync(success, data);
                                    },
                                    errorFn);
                            else {
                                subscriptionInProgress = false;
                                callAsync(success, data);
                            }
                        },
                        errorFn);
                };
                if (!iteroJSPayment)
                    //secretPaymentData=tetheredPaymentData here
                    successFn(secretPaymentData);
                else
                    iteroJSPayment.tetherPaymentInformation(paymentTotal, order.Currency, secretPaymentData, successFn, errorFn);
            } catch (e) {
                subscriptionInProgress = false;
                throw e;
            }
        };

        var createOrder2 = function (order, success, error) {
            if (!order)
                throw new SubscriptionError("ArgumentMissing: order");
            if (!order.Cart)
                throw new SubscriptionError("ArgumentMissing: order.Cart");
            if (!order.Customer)
                throw new SubscriptionError("ArgumentMissing: order.Customer");
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");

            order.Customer = sanitizeCustomerData(order.Customer);
            if (!validateCustomerData(order.Customer, error))
                return;

            post(subscriptionJs.apiUrl + "CustomerSelfService/signup/order", order, success, error);
        };

        var createOrder1 = function (cart, customerData, success, error) {
            if (!cart)
                throw new SubscriptionError("ArgumentMissing: cart");
            if (!customerData)
                throw new SubscriptionError("ArgumentMissing: customerData");
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");

            var dto = { Cart: cart, Customer: customerData };
            createOrder2(dto, success, error);
        };

        this.createOrder = function (param1, param2, param3, param4) {
            if (param1.Cart) {
                createOrder2(param1, param2, param3);
            }
            else {
                createOrder1(param1, param2, param3, param4);
            }
        };

        this.subscribe = function (iteroJSPayment, cart, customerData, secretPaymentData, success, error) {
            self.createOrder(cart, customerData, function (order) {
                self.paySignupInteractive(iteroJSPayment, secretPaymentData, order, success, error);
            }, error);
        };

        var previewTimer;
        var isFirstPreview = true;
        this.preview = function (cart, customerData, success, error, previewAfterTrial) {
            if (!cart)
                throw new SubscriptionError("ArgumentMissing: cart");
            if (!customerData)
                throw new SubscriptionError("ArgumentMissing: customerData");
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");

            if (isFirstPreview) {
                previewInternal(cart, customerData, success, error, previewAfterTrial);
                isFirstPreview = false;
                return;
            }
            else if (previewTimer) {
                clearTimeout(previewTimer);
            }
            previewTimer = setTimeout(function () { previewInternal(cart, customerData, success, error, previewAfterTrial); }, 700);
        };

        function previewInternal(cart, customerData, success, error, previewAfterTrial) {
            if (cart.ComponentSubscriptions)
                for (var i = 0; i < cart.ComponentSubscriptions.length; i++) {
                    if (!cart.ComponentSubscriptions[i].Quantity || cart.ComponentSubscriptions[i].Quantity == null)
                        cart.ComponentSubscriptions[i].Quantity = 0;
                }
            post(subscriptionJs.apiUrl + "CustomerSelfService/Preview", { cart: cart, customer: customerData, previewAfterTrial: previewAfterTrial ? previewAfterTrial : false }, success, error);
        }
    };

    // paymentConfig: { publicApiKey, popupCreate, popupClose, providerReturnUrl }
    subscriptionJs.finalizationUrl = null;
    subscriptionJs.Payment = function (paymentConfiguration, ready, error) {
        // private list of configured payment methods. This is the result we got from the server
        var availablePaymentMethods = null;
        var availablePaymentMethodEnum = null;

        //
        // constructor parameter validation
        //
        if (!paymentConfiguration)
            throw new SubscriptionError("ArgumentMissing: paymentConfiguration");
        if (!ready)
            throw new SubscriptionError("ArgumentMissing: ready");
        if (!error)
            throw new SubscriptionError("ArgumentMissing: error");
        if (!paymentConfiguration.publicApiKey)
            throw new SubscriptionError("ArgumentInvalid: paymentConfiguration missing publicApiKey");

        // copy payment config so we don't keep a reference to an object we don't own
        var paymentConfig =
        {
            publicApiKey: paymentConfiguration.publicApiKey,
            popupCreate: paymentConfiguration.popupCreate,
            popupClose: paymentConfiguration.popupClose,
            providerReturnUrl: paymentConfiguration.providerReturnUrl,
            termsOfServiceUrl: paymentConfiguration.termsOfServiceUrl
        };

        loadConfiguredPaymentMethods(function (paymentMethods) {
            availablePaymentMethods = paymentMethods.paymentMethods;
            availablePaymentMethodEnum = paymentMethods.paymentMethodEnum;
            loadLibraries(availablePaymentMethods, ready);
        }, error, paymentConfiguration.paymentMethods);

        // public getter for the configured payment methods. This is needed when you want to build
        // a dynamic selection of payment methods based on the server configuration, e.g. as done
        // by the default portal.
        this.getAvailablePaymentMethods = function () { return availablePaymentMethods; };

        this.getAvailablePaymentMethodEnum = function () { return availablePaymentMethodEnum; };

        this.tetherPaymentInformation = function (amount, currency, paymentData, success, error) {
            if (amount < 0) {
                throw new SubscriptionError("ArgumentError: amount: Negative payments aren't supported");
            }
            if (!currency || typeof currency !== "string" || currency.length !== 3)
                throw new SubscriptionError("ArgumentError: currency: not set or not a valid 3-letter string: " + currency);
            if (!paymentData)
                throw new SubscriptionError("ArgumentMissing: paymentData");
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");

            if (!validatePaymentMethod(paymentData.bearer))
                callAsync(error, createError(["InvalidConfiguration"], "No valid '" + paymentData.bearer + "' configuration"));
            if (amount === null)
                amount = getDefaultPreauth(paymentData.bearer);
            switch (paymentData.bearer) {                
                case subscriptionJs.BEARER.PayOne.Debit:
                case subscriptionJs.BEARER.PayOne.CreditCard:
                    paymentPayOne(amount, currency, paymentData, success, error);
                    break;
                case subscriptionJs.BEARER.PayOne.OnAccount:
                    callAsync(success, { "selectedPaymentMethod": paymentData.bearer, "returnUrl": paymentConfig.providerReturnUrl });
                    break;
                case subscriptionJs.BEARER.PayPal.PayPal:
                case subscriptionJs.BEARER.PayPal.BlackLabel:
                    callAsync(success, { "bearer": { "emailAddress": paymentData.emailAddress }, "selectedPaymentMethod": subscriptionJs.BEARER.PayPal.BlackLabel, "returnUrl": paymentConfig.providerReturnUrl });
                    break;
                case subscriptionJs.BEARER.None.None:
                    callAsync(success, { "selectedPaymentMethod": subscriptionJs.BEARER.None.None, "returnUrl": paymentConfig.providerReturnUrl });
                    break;
                case subscriptionJs.BEARER.FakePSP.FakePSP:
                case subscriptionJs.BEARER.FakePSP.BlackLabel:
                    callAsync(success, { "selectedPaymentMethod": "BlackLabel:FakeProvider", "returnUrl": paymentConfig.providerReturnUrl });
                    break;
                case subscriptionJs.BEARER.FakePSP.Debit:
                    if (!validateIBAN(paymentData, error))
                        return;
                    paymentFake(amount, currency, paymentData, success, error);
                    break;
                case subscriptionJs.BEARER.FakePSP.CreditCard:
                    paymentFake(amount, currency, paymentData, success, error);
                    break;
                case subscriptionJs.BEARER.InvoicePayment.InvoicePayment:
                case subscriptionJs.BEARER.InvoicePayment.BlackLabel:
                    callAsync(success, { "selectedPaymentMethod": subscriptionJs.BEARER.InvoicePayment.BlackLabel, "returnUrl": paymentConfig.providerReturnUrl });
                    break;
                case subscriptionJs.BEARER.Wirecard.Debit:
                case subscriptionJs.BEARER.Wirecard.CreditCard:
                    if (!availablePaymentMethods.Wirecard.CheckoutPage) {
                        if (!validateIBAN(paymentData, error))
                            return;
                        paymentWirecardCheckoutSeamless(amount, currency, paymentData, success, error);
                    }
                    else
                        callAsync(success, { "selectedPaymentMethod": paymentData.bearer, "returnUrl": paymentConfig.providerReturnUrl });
                    break;
                case subscriptionJs.BEARER.Stripe.CreditCard:
                case subscriptionJs.BEARER.Stripe.Debit:
                    paymentStripe(amount, currency, paymentData, success, error);
                    break;
                case subscriptionJs.BEARER.Heidelpay.Debit:
                case subscriptionJs.BEARER.Heidelpay.CreditCard:
                case subscriptionJs.BEARER.Unzer.Debit:
                case subscriptionJs.BEARER.Unzer.CreditCard:
                    if (getUnzerPaymentMethodSettings(availablePaymentMethods).CheckoutPage) {
                        callAsync(success, { "selectedPaymentMethod": paymentData.bearer, "returnUrl": paymentConfig.providerReturnUrl });
                    }
                    else {
                        callAsync(success, {
                            "bearer": {
                                "mandateText": paymentData.mandateText
                            }, "selectedPaymentMethod": paymentData.bearer, "returnUrl": paymentConfig.providerReturnUrl
                        });
                    }
                    break;
                case subscriptionJs.BEARER.SlimPay.Debit:
                case subscriptionJs.BEARER.SlimPay.CreditCard:
                    callAsync(success, { "selectedPaymentMethod": paymentData.bearer, "returnUrl": paymentConfig.providerReturnUrl });
                    break;
                case subscriptionJs.BEARER.GoCardless.Debit:
                    if (availablePaymentMethods.GoCardless.CheckoutPage)
                        callAsync(success, { "selectedPaymentMethod": paymentData.bearer, "returnUrl": paymentConfig.providerReturnUrl });
                    else
                        callAsync(success,
                            {
                                "bearer": { "holder": paymentData.accountHolder, "code": paymentData.bankRoutingCode, "account": paymentData.bankAccountNumber, "iban": paymentData.iban, country: paymentData.country || "DE", "mandateText": paymentData.mandateText }
                                , "selectedPaymentMethod": paymentData.bearer, "returnUrl": paymentConfig.providerReturnUrl
                            });
                    break;
                case subscriptionJs.BEARER.GoCardless.Betalingsservice:
                    if (availablePaymentMethods.GoCardless.CheckoutPage) {
                        callAsync(success,
                            {
                                "selectedPaymentMethod": paymentData.bearer,
                                "returnUrl": paymentConfig.providerReturnUrl
                            });
                    } else {
                        callAsync(success,
                            {
                                "bearer": { "holder": paymentData.accountHolder, "account": paymentData.bankAccountNumber, "code": paymentData.bankCode, "danishIdNumber": paymentData.danishIdNumber }
                                , "selectedPaymentMethod": paymentData.bearer, "returnUrl": paymentConfig.providerReturnUrl
                            });
                    }
                    break;
                case subscriptionJs.BEARER.WirecardElastic.Debit:
                    callAsync(success,
                        {
                            "bearer": { "holder": paymentData.accountHolder, "iban": paymentData.iban, "mandateText": paymentData.mandateText },
                            "selectedPaymentMethod": paymentData.bearer, "returnUrl": paymentConfig.providerReturnUrl
                        });
                    break;
                case subscriptionJs.BEARER.WirecardElastic.CreditCard:
                    var cardBrand = mapCardType(paymentData.cardNumber, "wirecardElastic", error);
                    if (!cardBrand)
                    {
                        return;
                    }
                    if (availablePaymentMethods.WirecardElastic.HostedPay)
                        callAsync(success, { "selectedPaymentMethod": paymentData.bearer, "returnUrl": paymentConfig.providerReturnUrl });
                    else if (availablePaymentMethods.WirecardElastic.SeamlessPay)
                        callAsync(success, { "selectedPaymentMethod": paymentData.bearer, "returnUrl": paymentConfig.providerReturnUrl });
                    break;
                case subscriptionJs.BEARER.Adyen.CreditCard:
                    if (availablePaymentMethods.Adyen.CcClientSideMode==='CustomCardComponent'){
                        callAsync(success, {
                            "bearer":
                                {
                                    "holder": paymentData.cardHolder,
                                    "encryptedCardNumber": paymentData.encryptedCardNumber,
                                    "encryptedSecurityCode": paymentData.encryptedSecurityCode,
                                    "encryptedExpiryMonth": paymentData.encryptedExpiryMonth,
                                    "encryptedExpiryYear": paymentData.encryptedExpiryYear,
                                },
                            "selectedPaymentMethod": paymentData.bearer, 
                            "returnUrl": paymentConfig.providerReturnUrl 
                        });
                    }
                    else
                        paymentAdyenCSEMode(paymentData, availablePaymentMethods.Adyen.GenerationTime, success, error);
                    break;
                case subscriptionJs.BEARER.Adyen.Debit:
                    if (!validateIBAN(paymentData, error))
                        return;
                    callAsync(success, {
                        "bearer":
                        {
                            "holder": paymentData.accountHolder,
                            "iban": paymentData.iban,
                            "mandateText": paymentData.mandateText
                        },
                        "selectedPaymentMethod": paymentData.bearer,
                        "returnUrl": paymentConfig.providerReturnUrl
                    });
                    break;
                case subscriptionJs.BEARER.Adyen.iDEAL:
                    callAsync(success, {
                        "bearer":
                            {
                                "issuer": paymentData.issuer,
                                "bankName": getiDEALBankName(paymentData.issuer)
                            },
                        "selectedPaymentMethod": paymentData.bearer,
                        "returnUrl": paymentConfig.providerReturnUrl
                    });
                    break;
                case subscriptionJs.BEARER.Worldline.CreditCard:
                    if (availablePaymentMethods.Worldline.CheckoutPage) {
                        callAsync(success,
                            {
                                "selectedPaymentMethod": paymentData.bearer,
                                "returnUrl": paymentConfig.providerReturnUrl
                            });
                    } else {
                        paymentWorldline(paymentData, success, error);
                    }
                    break;
                case subscriptionJs.BEARER.Worldpay.Debit:
                case subscriptionJs.BEARER.Worldpay.CreditCard:
                    if (availablePaymentMethods.Worldpay.CheckoutPage) {
                        callAsync(success,
                            {
                                "selectedPaymentMethod": paymentData.bearer,
                                "returnUrl": paymentConfig.providerReturnUrl
                            });
                    }
                    break;
                case subscriptionJs.BEARER.MobilePay.MobilePay:
                case subscriptionJs.BEARER.MobilePay.BlackLabel:
                    if (availablePaymentMethods.MobilePay.BlackLabel) {
                        callAsync(success,
                            {
                                "selectedPaymentMethod": subscriptionJs.BEARER.MobilePay.BlackLabel,
                                "returnUrl": paymentConfig.providerReturnUrl
                            });
                    }
                    break;
                case subscriptionJs.BEARER.NetsEasy.CreditCard:
                    callAsync(success,
                        {
                            "selectedPaymentMethod": subscriptionJs.BEARER.NetsEasy.CreditCard,
                            "returnUrl": paymentConfig.providerReturnUrl
                        });
                    break;
                case subscriptionJs.BEARER.PayEx.CreditCard:
                    callAsync(success,
                        {
                            "selectedPaymentMethod": subscriptionJs.BEARER.PayEx.CreditCard,
                            "returnUrl": paymentConfig.providerReturnUrl,
                            "termsOfServiceUrl": paymentConfig.termsOfServiceUrl
                        });
                    break;
                case subscriptionJs.BEARER.PayExInvoiceService.Autogiro:
                    callAsync(success,
                        {
                            "bearer":
                                {
                                    "NationalIdNumber": paymentData.nationalIdNumber,
                                },
                            "selectedPaymentMethod": paymentData.bearer,
                            "returnUrl": paymentConfig.providerReturnUrl
                        });
                    break;
                case subscriptionJs.BEARER.PayExInvoiceService.Avtalegiro:
                case subscriptionJs.BEARER.PayExInvoiceService.Betalingsservice:                    
                    callAsync(success,
                        {
                            "selectedPaymentMethod": paymentData.bearer,
                            "returnUrl": paymentConfig.providerReturnUrl
                        });
                    break;
                case subscriptionJs.BEARER.FarPay.Betalingsservice:
                    callAsync(success,
                        {
                            "selectedPaymentMethod": subscriptionJs.BEARER.FarPay.Betalingsservice,
                            "returnUrl": paymentConfig.providerReturnUrl
                        });
                    break;
                case subscriptionJs.BEARER.Mollie.Debit:
                    callAsync(success,
                        {
                            "bearer": {
                                "holder": paymentData.accountHolder,
                                "iban": paymentData.iban,
                                "mandateText": paymentData.mandateText,
                                "mandateReference": paymentData.mandateReference
                            },
                            "selectedPaymentMethod": paymentData.bearer,
                            "returnUrl": paymentConfig.providerReturnUrl
                        });
                    break;
                case subscriptionJs.BEARER.Mollie.CreditCard:
                    callAsync(success,
                        {
                            "selectedPaymentMethod": subscriptionJs.BEARER.Mollie.CreditCard,
                            "returnUrl": paymentConfig.providerReturnUrl,
                        });
                    break;
                case subscriptionJs.BEARER.AmazonPay.AmazonPay:
                case subscriptionJs.BEARER.AmazonPay.BlackLabel:
                    callAsync(success,
                        {
                            "selectedPaymentMethod": subscriptionJs.BEARER.AmazonPay.BlackLabel,
                            "returnUrl": paymentConfig.providerReturnUrl
                        });
                    break;
                case subscriptionJs.BEARER.Reepay.CreditCard:
                    callAsync(success,
                        {
                            "selectedPaymentMethod": subscriptionJs.BEARER.Reepay.CreditCard,
                            "returnUrl": paymentConfig.providerReturnUrl
                        });
                    break;
                case subscriptionJs.BEARER.SepaXml.Debit:
                    callAsync(success,
                        {
                            "bearer": {
                                "holder": paymentData.accountHolder,
                                "iban": paymentData.iban,
                                "mandateText": paymentData.mandateText,
                                "mandateReference": paymentData.mandateReference
                            },
                            "selectedPaymentMethod": subscriptionJs.BEARER.SepaXml.Debit,
                            "returnUrl": paymentConfig.providerReturnUrl
                        });
                    break;
                default:
                    throw new SubscriptionError("Unknown payment bearer '" + paymentData.bearer + "'!");
            }
        };

        this.isFinalTetherPaymentInformationCallRequired = function (paymentData) {
            switch (paymentData.bearer) {
                case subscriptionJs.BEARER.Wirecard.Debit:
                case subscriptionJs.BEARER.Wirecard.CreditCard:
                    if (availablePaymentMethods.Wirecard.CheckoutPage)
                        return true;
                    else
                        return false;
                case subscriptionJs.BEARER.Heidelpay.Debit:
                case subscriptionJs.BEARER.Heidelpay.CreditCard:
                case subscriptionJs.BEARER.Unzer.Debit:
                case subscriptionJs.BEARER.Unzer.CreditCard:
                    if (getUnzerPaymentMethodSettings(availablePaymentMethods).CheckoutPage)
                        return false;
                    else
                        return true;
                case subscriptionJs.BEARER.WirecardElastic.CreditCard:
                        return true;
                case subscriptionJs.BEARER.Adyen.CreditCard:
                case subscriptionJs.BEARER.Worldline.CreditCard:
                case subscriptionJs.BEARER.Worldpay.CreditCard:
                case subscriptionJs.BEARER.Worldpay.Debit:
                case subscriptionJs.BEARER.AmazonPay.BlackLabel:
                case subscriptionJs.BEARER.AmazonPay.AmazonPay:
                    return true;
                default:
                    return false;
            }
        };

        this.isPSPCheckoutPageIntegration = function (bearer) {
            //no payment data shown and customer is redirected to psp page
            switch (bearer) {
                case subscriptionJs.BEARER.Wirecard.Debit:
                case subscriptionJs.BEARER.Wirecard.CreditCard:
                    if (availablePaymentMethods.Wirecard.CheckoutPage)
                        return true;
                    break;
                case subscriptionJs.BEARER.Heidelpay.Debit:
                case subscriptionJs.BEARER.Heidelpay.CreditCard:
                case subscriptionJs.BEARER.Unzer.Debit:
                case subscriptionJs.BEARER.Unzer.CreditCard:
                    if (getUnzerPaymentMethodSettings(availablePaymentMethods).CheckoutPage)
                        return true;
                    break;
                case subscriptionJs.BEARER.GoCardless.Debit:
                    if (availablePaymentMethods.GoCardless.CheckoutPage)
                        return true;
                    break;
                case subscriptionJs.BEARER.Reepay.CreditCard:
                    return true;
            }
            return false;

        };

        this.isTetherPaymentInformation2Supported = function (bearer) {
            if (this.isFinalTetherPaymentInformationCallRequired({ bearer: bearer }))
                return false;
            if (this.isPSPCheckoutPageIntegration(bearer))
                return false;

            switch (bearer) {
                case subscriptionJs.BEARER.PayPal.PayPal:
                    return false;
            }

            return true;
        };

        this.isRedirectFromIFrame = function(bearer){
            switch (bearer) {
                case subscriptionJs.BEARER.Heidelpay.CreditCard:
                case subscriptionJs.BEARER.Unzer.CreditCard:
                case subscriptionJs.BEARER.Heidelpay.Debit:
                case subscriptionJs.BEARER.Unzer.Debit:
                    return getUnzerPaymentMethodSettings(availablePaymentMethods).CheckoutPage;                    
                default:
                    return true;                    
            }
        }
        
        this.finalTetherPaymentInformation = function (serverData, amount, currency, paymentData, success, error) {
            if (!serverData)
                throw new SubscriptionError("ArgumentMissing: serverData");

            if (amount === null)
                amount = getDefaultPreauth(paymentData.bearer);

            if (!this.isFinalTetherPaymentInformationCallRequired(paymentData))
                throw new SubscriptionError("FinalTetherPaymentInformationCall is not required for " + paymentData.bearer);
            switch (paymentData.bearer) {
                case subscriptionJs.BEARER.Wirecard.Debit:
                case subscriptionJs.BEARER.Wirecard.CreditCard:
                    if (availablePaymentMethods.Wirecard.CheckoutPage)
                        postRedirect(serverData.Data, serverData.Url, "hidden");
                    else
                        throw new SubscriptionError("FinalTetherPaymentInformationCall is not required for " + paymentData.bearer);
                    break;
                case subscriptionJs.BEARER.Heidelpay.Debit:
                case subscriptionJs.BEARER.Heidelpay.CreditCard:
                case subscriptionJs.BEARER.Unzer.Debit:
                case subscriptionJs.BEARER.Unzer.CreditCard:
                    if (getUnzerPaymentMethodSettings(availablePaymentMethods).CheckoutPage)
                        throw new SubscriptionError("FinalTetherPaymentInformationCall is not required for " + paymentData.bearer);
                    else
                        paymentUnzer(serverData, paymentData, success, error);
                    break;
                case subscriptionJs.BEARER.WirecardElastic.CreditCard:
                    payWirecardElastic(availablePaymentMethods.WirecardElastic, serverData, amount, currency, paymentData,
                        success, error);
                    break;
                case subscriptionJs.BEARER.Adyen.CreditCard:
                case subscriptionJs.BEARER.Worldline.CreditCard:
                    if (serverData.Url && serverData.Data) {
                        postRedirect(serverData.Data, serverData.Url, "hidden");
                    } else {
                        callAsync(success, serverData);
                    }
                    break;
                case subscriptionJs.BEARER.Worldpay.Debit:
                case subscriptionJs.BEARER.Worldpay.CreditCard:
                    if (serverData.Url) {
                        postRedirect(serverData.Data, serverData.Url, "hidden");
                    }
                    break;
                case subscriptionJs.BEARER.AmazonPay.AmazonPay:
                case subscriptionJs.BEARER.AmazonPay.BlackLabel:
                    paymentAmazonPay(serverData, error);
                    break;
                default:
                    throw new SubscriptionError("FinalTetherPaymentInformationCall is not required for " + paymentData.bearer);
            }
        };

        function getiDEALBankName(issuer) {
            var bank = availablePaymentMethods.Adyen.Banks.find(bank => { return bank.Issuer === issuer });

            if (bank) {
                return bank.BankName;
            }

            return "";
        }

        function paymentAmazonPay(serverData, errorCallback) {
            let buttonElement = document.createElement('div');
            buttonElement.id = "AmazonPayButton";
            buttonElement.hidden = true;
            if (document.body) {
                document.body.appendChild(buttonElement);
            } else {
                document.appendChild(buttonElement);
            }

            let isSandbox = serverData.Data.mode === "Test";

            try {
                let amazonPayButton = amazon.Pay.renderButton('#AmazonPayButton', {
                    sandbox: isSandbox,
                    merchantId: serverData.Data.merchantId,
                    publicKeyId: serverData.Data.publicKeyId,
                    ledgerCurrency: 'EUR', //Required to be EUR for EU account
                    checkoutLanguage: serverData.Data.checkoutLanguage,
                    productType: 'PayOnly',
                    placement: 'Checkout',
                    buttonColor: 'Gold',
                });

                amazonPayButton.initCheckout({
                    createCheckoutSessionConfig: {
                        payloadJSON: serverData.Data.payload,
                        signature: serverData.Data.signature,
                        publicKeyId: serverData.Data.publicKeyId
                    }
                });
            } catch (e) {
                callAsync(errorCallback, createError(["UnmappedError"], "Incorrect payment data provided!"));
            }
        }

        function paymentPayOne(amount, currency, paymentData, successCallback, errorCallback) {
            if (!PayoneRequest)
                throw new SubscriptionError("paymentPayOne called, but payone bridge not loaded!");

            var payOne = availablePaymentMethods.PayOne;
            var paymentMethod = paymentData.bearer;
            processCCCheckResponse = function processCCCheckResponse(response) {
                var status = response.get('status');
                if (status !== 'VALID') {
                    callAsync(errorCallback, mapPspError(response));
                }
                else {
                    var bearer = {
                        holder: paymentData.cardHolder,
                        pseudoCardPan: response.get('pseudocardpan'),
                        truncatedCardPan: response.get('truncatedcardpan'),
                        cardType: paymentData.cardType,
                        expiryMonth: paymentData.expiryMonth,
                        expiryYear: paymentData.expiryYear
                    };

                    paymentData = { "bearer": bearer, "selectedPaymentMethod": paymentMethod, "returnUrl": paymentConfig.providerReturnUrl };
                    callAsync(successCallback, paymentData);
                }
            };

            processAccountCheckResponse = function (response) {
                var status = response.get('status');
                if (status !== 'VALID') {
                    callAsync(errorCallback, mapPspError(response));
                }
                else {
                    var bearer = {
                        holder: paymentData.accountHolder,
                        country: paymentData.country || "DE",
                        account: response.get('bankaccount'),
                        code: response.get('bankcode'),
                        iban: paymentData.iban,
                        mandateReference: paymentData.mandateReference,
                        mandateText: paymentData.mandateText,
                        bic: paymentData.bic
                    };

                    paymentData = { "bearer": bearer, "selectedPaymentMethod": paymentMethod, "returnUrl": paymentConfig.providerReturnUrl };
                    callAsync(successCallback, paymentData);
                }
            };

            var options;
            var request;
            var data;
            if (paymentMethod === subscriptionJs.BEARER.PayOne.CreditCard) {
                paymentData.cardType = mapCardType(paymentData.cardNumber, "payOne", errorCallback);
                if (!paymentData.cardType) {
                    return;
                }
                data = {
                    request: 'creditcardcheck',
                    mode: payOne.Mode.toLowerCase(),
                    mid: payOne.MerchantId,
                    aid: payOne.AccountId,
                    portalid: payOne.PortalId,
                    //encoding : 'UTF-8',
                    storecarddata: 'yes',
                    hash: payOne.CreditCardHash,
                    cardholder: paymentData.cardHolder,
                    cardpan: paymentData.cardNumber,
                    cardtype: paymentData.cardType,
                    cardexpiremonth: paymentData.expiryMonth,
                    cardexpireyear: paymentData.expiryYear,
                    cardcvc2: paymentData.cvc,
                    language: 'de'
                };
                options = {
                    return_type: 'object',
                    callback_function_name: 'processCCCheckResponse'
                };
                request = new PayoneRequest(data, options);
                request.checkAndStore();
            } else if (paymentMethod === subscriptionJs.BEARER.PayOne.Debit) {
                data = {
                    request: 'bankaccountcheck',
                    mode: payOne.Mode.toLowerCase(),
                    mid: payOne.MerchantId,
                    aid: payOne.AccountId,
                    portalid: payOne.PortalId,
                    //encoding : 'UTF-8',
                    hash: payOne.BankAccountHash,
                    language: 'de'
                };

                if (paymentData.iban) {
                    data.iban = paymentData.iban;
                    if (paymentData.bic) {
                        data.bic = paymentData.bic;
                    }
                }
                else {
                    data.bankcountry = paymentData.country || "DE";
                    data.bankaccount = paymentData.bankAccountNumber || "";
                    data.bankcode = paymentData.bankRoutingCode || "";
                }

                options = {
                    return_type: 'object',
                    callback_function_name: 'processAccountCheckResponse'
                };
                request = new PayoneRequest(data, options);
                request.checkAndStore();
            } else {
                throw new SubscriptionError("Invalid payment method given to paymentPayOne!");
            }
        }

        function paymentWirecardCheckoutSeamless(amount, currency, paymentData, successCallback, errorCallback) {
            var paymentMethod = paymentData.bearer;
            post(subscriptionJs.apiUrl + "CustomerSelfService/PaymentProviderInit", {
                selectedPaymentMethod: paymentMethod,
                entityId: paymentConfig.publicApiKey
            },
                function (dto) {
                    bindReady(function () {
                        
                        loadScript(dto.ClientInitializationURL, function () {

                            var dataStorage = new WirecardCEE_DataStorage();
                            // initializes the JavaScript object containing the payment specific information and data
                            var paymentInformation = {};
                            if (paymentMethod === subscriptionJs.BEARER.Wirecard.CreditCard) {
                                paymentInformation.pan = paymentData.cardNumber;
                                paymentInformation.expirationMonth = paymentData.expiryMonth;
                                paymentInformation.expirationYear = paymentData.expiryYear;
                                paymentInformation.cardholdername = paymentData.cardHolder;
                                paymentInformation.cardverifycode = paymentData.cvc;

                                dataStorage.storeCreditCardInformation(paymentInformation, function (data) {
                                    var err = data.getErrors();
                                    if (err) {
                                        callAsync(errorCallback, mapPspError(err));
                                    } else {
                                        var r = data.response.paymentInformation;
                                        var expY = 0;
                                        var expM = 0;
                                        var exp = r.expiry.split('/');
                                        if (exp.length > 1) {
                                            expM = exp[0];
                                            expY = exp[1];
                                        }
                                        if (exp.length === 2)
                                            var bearer = {
                                                holder: r.cardholdername,
                                                pseudoCardPan: r.anonymousPan, //maskedPan like "950000******0001" also present
                                                cardType: r.brand,
                                                expiryYear: expY,
                                                expiryMonth: expM,
                                                storageId: data.response.storageId,
                                                paymentIdentifier: dto.PaymentIdentifier
                                            };
                                        paymentData = { "bearer": bearer, "selectedPaymentMethod": paymentMethod, "returnUrl": paymentConfig.providerReturnUrl };
                                        callAsync(successCallback, paymentData);
                                    }
                                });
                            }
                            else {
                                paymentInformation.bankAccountIban = paymentData.iban;
                                //Optional
                                paymentInformation.accountOwner = paymentData.accountHolder; 

                                // stores sensitive data to the Wirecard data storage
                                dataStorage.storeSepaDdInformation(paymentInformation, function (data) {
                                    var err = data.getErrors();
                                    if (err) {
                                        callAsync(errorCallback, mapPspError(err));
                                    } else {
                                        var r = data.response.paymentInformation;
                                        var bearer = {
                                            iban: r.bankAccountIban,
                                            holder: r.accountOwner,
                                            storageId: data.response.storageId,
                                            paymentIdentifier: dto.PaymentIdentifier,
                                            mandateReference: paymentData.mandateReference,
                                            mandateText: paymentData.mandateText
                                        };
                                        paymentData = { "bearer": bearer, "selectedPaymentMethod": paymentMethod, "returnUrl": paymentConfig.providerReturnUrl };
                                        callAsync(successCallback, paymentData);
                                    }
                                });
                            }

                        });
                    });
                },
                errorCallback);

        }

        function paymentStripe(amount, currency, paymentData, successCallback, errorCallback) {

            var paymentMethod = paymentData.bearer;

            if (!Stripe && paymentMethod === subscriptionJs.BEARER.Stripe.CreditCard)
                throw new SubscriptionError("paymentStripe called, but Stripe bridge not loaded!");

            if (paymentMethod !== subscriptionJs.BEARER.Stripe.CreditCard && paymentMethod !== subscriptionJs.BEARER.Stripe.Debit) {
                throw new SubscriptionError("Invalid payment method given to paymentStripe!");
            }

            var mandateText = paymentData.mandateText;
            if (paymentMethod === subscriptionJs.BEARER.Stripe.CreditCard) {
                var stripeCardData = {
                    number: paymentData.cardNumber,
                    cvc: paymentData.cvc,
                    exp_month: paymentData.expiryMonth,
                    exp_year: paymentData.expiryYear,
                    name: paymentData.cardHolder
                };

                Stripe.createToken(stripeCardData, function (status, response) {
                    if (status.toString().lastIndexOf('2', 0) !== 0) {
                        callAsync(errorCallback, mapPspError(response));
                    }
                    else if (response) {
                        paymentData = { "bearer": { "token": response.id }, "selectedPaymentMethod": paymentMethod, "returnUrl": paymentConfig.providerReturnUrl };
                        if (mandateText)
                            paymentData.bearer.mandateText = mandateText;
                        callAsync(successCallback, paymentData);
                    }
                });
            } else {
                var stripeDebitInfo = {
                    "bearer": {
                        mandateText: mandateText,
                        holder: paymentData.accountHolder,
                        iban: paymentData.iban,
                        //mandateReference: paymentData.mandateReference,
                        //emailAddress: paymentData.emailAddress
                    },
                    selectedPaymentMethod: paymentMethod,
                    "returnUrl": paymentConfig.providerReturnUrl
                };
                callAsync(successCallback, stripeDebitInfo);
            }
        }

        function paymentUnzer(serverData, paymentData, successCallback, errorCallback) {
            var submitUrl = serverData.Url;
            if (!submitUrl)
                throw new SubscriptionError("ArgumentError: Url not specified");

            if (!serverData.Data.finalizationUrl)
                throw new SubscriptionError("ArgumentError: FinalizationUrl not specified for Unzer");
            subscriptionJs.finalizationUrl = serverData.Data.finalizationUrl;

            var data;
            if (paymentData.bearer === subscriptionJs.BEARER.Heidelpay.CreditCard 
                || paymentData.bearer === subscriptionJs.BEARER.Unzer.CreditCard) {
                var cardBrand = mapCardType(paymentData.cardNumber, "unzer", errorCallback);
                if (!cardBrand) {
                    return;
                }
                data = {
                    'ACCOUNT.NUMBER': paymentData.cardNumber,
                    'ACCOUNT.BRAND': cardBrand,
                    'ACCOUNT.HOLDER': paymentData.cardHolder,
                    'ACCOUNT.EXPIRY_MONTH': paymentData.expiryMonth,
                    'ACCOUNT.EXPIRY_YEAR': paymentData.expiryYear,
                    'ACCOUNT.VERIFICATION': paymentData.cvc
                };
            }
            else if (paymentData.bearer === subscriptionJs.BEARER.Heidelpay.Debit 
                || paymentData.bearer === subscriptionJs.BEARER.Unzer.Debit) {
                data = {
                    'ACCOUNT.NUMBER': paymentData.bankAccountNumber,
                    'ACCOUNT.HOLDER': paymentData.accountHolder,
                    'ACCOUNT.BANK': paymentData.bankRoutingCode,
                    'ACCOUNT.IBAN': paymentData.iban
                };
            }

            postRedirect(data, submitUrl, "text");
        }

        function paymentFake(amount, currency, paymentData, successCallback, errorCallback) {

            if (!FakeRequest)
                throw new SubscriptionError("paymentFake called, but fake bridge not loaded!");

            var data;
            if (paymentData.bearer === subscriptionJs.BEARER.FakePSP.CreditCard) {
                data = {
                    request: 'creditcardcheck',
                    currency: currency,
                    cardHolder: paymentData.cardHolder,
                    cardNumber: paymentData.cardNumber,
                    exp_month: paymentData.expiryMonth,
                    exp_year: paymentData.expiryYear,
                    cvc: paymentData.cvc,
                    cardholder: paymentData.cardHolder
                };
            } else if (paymentData.bearer === subscriptionJs.BEARER.FakePSP.Debit) {
                data = {
                    request: 'bankaccountcheck',
                    country: paymentData.country || "DE",
                    accountHolder: paymentData.accountHolder,
                    iban: paymentData.iban,
                    bic: paymentData.bic,
                    mandateText: paymentData.mandateText
                };
            } else {
                throw new SubscriptionError("Invalid payment method given to paymentFake!");
            }

            var processCheckFakeResponse = function (response) {
                //for FakePSP we have different naming of bearer and what we are submitting
                //see "selectedPaymentMethod": "Debit:FakeProvider" vs BEARER.FakePSP.Debit
                if (response && response.status === 'ERROR') {
                    console.log([FAKE_ERROR_MAP[response.errorcode]]);

                    callAsync(errorCallback, createError([FAKE_ERROR_MAP[response.errorcode]], response.errormessage, FAKE_ERROR_MAP[response.errorcode]));
                }
                else {
                    if (paymentData.bearer === subscriptionJs.BEARER.FakePSP.CreditCard) {
                        callAsync(successCallback,
                            {
                                "bearer": {
                                    "pseudoCardPan": paymentData.cardNumber,
                                    "TruncatedCardPan": "****",
                                    "ExpiryMonth": paymentData.expiryMonth,
                                    "ExpiryYear": paymentData.expiryYear,
                                    "Holder": paymentData.cardHolder
                                },
                                "selectedPaymentMethod": "CreditCard:FakeProvider",
                                "returnUrl": paymentConfig.providerReturnUrl
                            });
                    } else if (paymentData.bearer === subscriptionJs.BEARER.FakePSP.Debit) {
                        var bearer = {
                            "holder": paymentData.accountHolder,
                            "code": paymentData.bankRoutingCode,
                            "account": paymentData.bankAccountNumber,
                            "iban": paymentData.iban,
                            "bic": paymentData.bic,
                            'mandateText': paymentData.mandateText,
                            'mandateReference': paymentData.mandateReference
                        };
                        paymentData = {
                            "bearer": bearer,
                            "selectedPaymentMethod": "Debit:FakeProvider",
                            "returnUrl": paymentConfig.providerReturnUrl
                        };
                        callAsync(successCallback, paymentData);
                    }
                }
            };

            var options = {
                return_type: 'object',
                callback_function_name: processCheckFakeResponse
            };

            var request = new FakeRequest(data, options);
            request.checkAndStore();
        }

        function paymentAdyenCSEMode(paymentData, generationTime, successCallback, errorCallback) {
            if (!adyen || !adyen.cse.available || !adyen.createEncryption) {
                throw new SubscriptionError("Adyen called, but Adyen Client-Side Encryption Library not loaded!");
            }

            var paymentMethod = paymentData.bearer;
            if (paymentMethod !== subscriptionJs.BEARER.Adyen.CreditCard)
                throw new SubscriptionError("Adyen Client-Side Encryption works only for credit cards!");
            var options = {}; // See adyen.encrypt.nodom.html for details
            var cseInstance = adyen.createEncryption(options);
            if (!cseInstance) {
                throw new SubscriptionError("Adyen called, but Adyen Client-Side Encryption Library can not create encryption!");
            }

            var cardData = {
                number: paymentData.cardNumber,
                cvc: paymentData.cvc,
                holderName: paymentData.cardHolder,
                expiryMonth: paymentData.expiryMonth,
                expiryYear: paymentData.expiryYear,
                generationtime: generationTime
            };
            var encryptedData = cseInstance.encrypt(cardData);
            if (!encryptedData) {
                callAsync(errorCallback,
                    createError(["UnmappedError"], "Not correct payment data provided!"));
            } else {
                var bearer = {
                    "bearer": { "encryptedPaymentInfo": encryptedData },
                    "selectedPaymentMethod": paymentMethod,
                    "returnUrl": paymentConfig.providerReturnUrl
                };
                callAsync(successCallback, bearer);
            }

        }

        function paymentWorldline(paymentData, successCallback, errorCallback) {

            if (!sdpx || !sdpx.encrypt) {
                throw new SubscriptionError("Worldline called, but Worldline Client-Side Encryption Library not loaded!");
            }
            var paymentMethod = paymentData.bearer;
            if (paymentMethod !== subscriptionJs.BEARER.Worldline.CreditCard) {
                throw new SubscriptionError("Worldline Client-Side Encryption works only for credit cards!");
            }
            try {
                var encryptedData = encryptPaymentDataForWorldline({ cardNumber: paymentData.cardNumber, cardCsc: paymentData.cvc }, availablePaymentMethods.Worldline.CseKey, availablePaymentMethods.Worldline.CseKeyVersion, errorCallback);
                if (!encryptedData) {
                    callAsync(errorCallback, createError(["UnmappedError"], "Not correct payment data provided!"));
                } else {
                    var bearer = {
                        "bearer": {
                            encryptedCard: encryptedData.cardNumber,
                            encryptedCsc: encryptedData.cardCsc,
                            expiryMonth: paymentData.expiryMonth,
                            expiryYear: paymentData.expiryYear,
                            name: paymentData.cardHolder
                        },
                        "selectedPaymentMethod": paymentMethod,
                        "returnUrl": paymentConfig.providerReturnUrl
                    };
                    callAsync(successCallback, bearer);
                }
            } catch (e) {
                callAsync(errorCallback, createError(["UnmappedError"], "Not correct payment data provided!"));
            }
        }

        function encryptPaymentDataForWorldline(paymentData, cseKey, cseKeyVersion,  onError) {
            var form = document.createElement('form');
            form.id = 'worldlineCseForm';
            form.style.display = "none";
            for (var originalData in paymentData) {
                if (paymentData.hasOwnProperty(originalData)) {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.id = originalData;
                    input.setAttribute('sdpx-encrypted', '');
                    input.value = decodeURIComponent(paymentData[originalData]);
                    form.appendChild(input);
                }
            }
            var submit = document.createElement('input');
            submit.type = 'submit';
            form.appendChild(submit);

            if (document.body) {
                document.body.appendChild(form);
            } else {
                document.appendChild(form);
            }

            var paymentForm = sdpx.encrypt.onSubmitEncryptForm(form, cseKey, cseKeyVersion);
            paymentForm.setErrorHandler(errorHandler);
            form.onsubmit = function (event) {
                event.preventDefault();
            };
            submit.click();
            function errorHandler(error) {
                onError();
            }

            for (var resultData in paymentData) {
                if (paymentData.hasOwnProperty(resultData)) {
                    paymentData[resultData] = form[resultData].value;
                }
            }
            return paymentData;
        }

        var librariesLoaded = false;
        var librariesToBeLoaded = 0;
        librariesLoaded = 0;

        function loadLibraries(paymentMethods, loaded) {
            // loadLibraries() must have valid payment methods and the DOM must be loaded.

            var checkLoaded = function () {
                librariesLoaded++;
                console.log(librariesLoaded + " PSP scripts loaded");
                if (librariesLoaded == librariesToBeLoaded) {
                    console.log("Loading PSP scripts complete");
                    loaded();
                }
            };

            if (!paymentMethods) {
                throw new SubscriptionError("MissingArgument: paymentMethods");
            }
            if (!loaded) {
                throw new SubscriptionError("MissingArgument: loaded");
            }

            console.log("Determine required PSP scripts to be loaded");

            if (librariesLoaded) {
                console.log("PSP libs already loaded. Skip...");
                return;
            }

            console.log("No PSP scripts loaded yet");

            if (paymentMethods.PayOne) {
                console.log("PayOne script required");
                librariesToBeLoaded++;
            }
            if (paymentMethods.Stripe) {
                console.log("Stripe script required");
                librariesToBeLoaded++;
            }

            if (paymentMethods.FakePSP) {
                console.log("FakePSP script required");
                librariesToBeLoaded++;
            }

            if (paymentMethods.WirecardElastic && paymentMethods.WirecardElastic.CreditCard) {
                console.log("WirecardElastic script required");
                librariesToBeLoaded++;
            }
            const adyenClientSideEncryptionMode='ClientSideEncryption';
            if (paymentMethods.Adyen && paymentMethods.Adyen.CreditCard  && paymentMethods.Adyen.CcClientSideMode===adyenClientSideEncryptionMode) {
                console.log("Adyen script required");
                librariesToBeLoaded++;
            }

            if (paymentMethods.Worldline && paymentMethods.Worldline.CreditCard) {
                console.log("Worldline script required");
                librariesToBeLoaded++;
            }

            if (paymentMethods.AmazonPay) {
                console.log("AmazonPay script required");
                librariesToBeLoaded++;
            }

            if (librariesToBeLoaded === 0) {
                console.log("No PSP JS scripts to be loaded");
                loaded();
            }
            else {

                if (paymentMethods.FakePSP) {
                    bindReady(function () {
                        console.log("Start loading FakePSP script");
                        loadScript(subscriptionJs.apiUrl.replace('api/v1/', '') + "SelfService/FakeProviderBridge", checkLoaded);
                    });
                }
                if (paymentMethods.PayOne) {
                    PAYONE_CLIENT_API_URL = "https://secure.pay1.de/client-api/";
                    bindReady(function () {
                        console.log("Start loading PayOne script");
                        loadScript("https://secure.pay1.de/client-api/js/ajax.js", checkLoaded);
                    });
                }
                if (paymentMethods.Stripe) {
                    bindReady(function () {
                        console.log("Start loading Stripe script");
                        loadScript("https://js.stripe.com/v2/stripe.js",
                            function () {
                                if (Stripe)
                                    Stripe.setPublishableKey(paymentMethods.Stripe.PublicKey);
                                else
                                    throw new SubscriptionError("Stripe bridge loading failed!");
                                checkLoaded();
                            });
                    });
                }
                if (paymentMethods.WirecardElastic && paymentMethods.WirecardElastic.CreditCard) {
                    bindReady(function () {
                        loadWirecardElasticLibrary(paymentMethods.WirecardElastic, checkLoaded);
                    });
                }
                if (paymentMethods.Adyen && paymentMethods.Adyen.CreditCard && paymentMethods.Adyen.CcClientSideMode===adyenClientSideEncryptionMode) {
                    bindReady(function () {
                        bindReady(function () {
                            console.log("Start loading Adyen script");
                            loadScript(paymentMethods.Adyen.JsLibraryLocation, function () {
                                if (!adyen || !adyen.cse.available || !adyen.createEncryption) {
                                    throw new SubscriptionError("Adyen script loading failed!");
                                }
                                checkLoaded();
                            }, function () { throw new SubscriptionError("Adyen script loading failed!"); });
                        });
                    });
                }
                if (paymentMethods.Worldline && paymentMethods.Worldline.CreditCard) {
                    bindReady(function () {
                        bindReady(function () {
                            var url = paymentMethods.Worldline.CseLibraryLocation;
                            console.log("Start loading Worldline script");
                            loadScript(url, function () {
                                if (!sdpx || !sdpx.encrypt ) {
                                    throw new SubscriptionError("Worldline script loading failed!");
                                }
                                checkLoaded();
                            }, function () { throw new SubscriptionError("Worldline script loading failed!"); });
                        });
                    });
                }
                if (paymentMethods.AmazonPay){
                    bindReady(function (){
                        console.log("Start loading AmazonPay script");
                        loadScript("https://static-eu.payments-amazon.com/checkout.js", checkLoaded);
                    });
                }
            }
        }

        function loadConfiguredPaymentMethods(success, error, methodsFilter) {
            if (!success)
                throw new SubscriptionError("ArgumentMissing: success");
            if (!error)
                throw new SubscriptionError("ArgumentMissing: error");

            get(subscriptionJs.apiUrl + "CustomerSelfService/PaymentMethods", { entityId: paymentConfig.publicApiKey },
                function (data) {
                    var result = { paymentMethods: {}, paymentMethodEnum: [] };

                    // walk through all payment methods
                    // look for the "CreditCard" and "Debit" magic strings (those are bearers), and concatenate them
                    var tryToAddResult = function (methodEnum, key) {
                        if (methodsFilter && methodsFilter.length > 0) {
                            var j = 0;
                            while (j < methodsFilter.length && methodsFilter[j] !== methodEnum) {
                                j++;
                            }
                            if (methodsFilter.length === j)
                                methodEnum = null;
                        }
                        if (methodEnum) {
                            result.paymentMethodEnum.push(methodEnum);
                            if (!result.paymentMethods[key])
                                result.paymentMethods[key] = data[key];
                        }
                    };
                    var keys = Object.keys(data);

                    for (var i = 0; i < keys.length; i++) {
                        var key = keys[i];
                        if (data[key]['CreditCard'])
                            tryToAddResult("CreditCard" + ":" + key, key);
                        if (data[key]['DirectDebit'])
                            tryToAddResult("Debit" + ":" + key, key);
                        if (data[key]['OnAccount'])
                            tryToAddResult("OnAccount" + ":" + key, key);
                        if (data[key]["Betalingsservice"])
                            tryToAddResult("Betalingsservice" + ":" + key, key);
                        if (data[key]["iDEAL"])
                            tryToAddResult("iDEAL" + ":" + key, key);
                        if (data[key]["Autogiro"])
                            tryToAddResult("Autogiro" + ":" + key, key);
                        if (data[key]["Avtalegiro"])
                            tryToAddResult("Avtalegiro" + ":" + key, key);
                        if (!data[key]['CreditCard'] && !data[key]['DirectDebit'] && !data[key]['OnAccount'] 
                            && !data[key]['Betalingsservice'] && !data[key]['iDEAL'] && !data[key]['Autogiro'] 
                            && !data[key]['Avtalegiro'])
                            tryToAddResult(key, key);
                    }
                    callAsync(success, result);
                }, error);
        }

        function validatePaymentMethod(bearer) {
            switch (bearer) {
                case subscriptionJs.BEARER.PayOne.Debit:
                case subscriptionJs.BEARER.PayOne.CreditCard:
                case subscriptionJs.BEARER.PayOne.OnAccount:
                    if (availablePaymentMethods.PayOne)
                        return true;
                    break;
                case subscriptionJs.BEARER.PayPal.PayPal:
                case subscriptionJs.BEARER.PayPal.BlackLabel:
                    if (availablePaymentMethods.PayPal)
                        return true;
                    break;
                case subscriptionJs.BEARER.None.None:
                    return true;
                case subscriptionJs.BEARER.FakePSP.FakePSP:
                case subscriptionJs.BEARER.FakePSP.BlackLabel:
                case subscriptionJs.BEARER.FakePSP.Debit:
                case subscriptionJs.BEARER.FakePSP.CreditCard:
                    if (availablePaymentMethods.FakePSP)
                        return true;
                    break;
                case subscriptionJs.BEARER.InvoicePayment.InvoicePayment:
                case subscriptionJs.BEARER.InvoicePayment.BlackLabel:
                    if (availablePaymentMethods.InvoicePayment)
                        return true;
                    break;
                case subscriptionJs.BEARER.Wirecard.Debit:
                case subscriptionJs.BEARER.Wirecard.CreditCard:
                    if (availablePaymentMethods.Wirecard)
                        return true;
                    break;
                case subscriptionJs.BEARER.Stripe.CreditCard:
                case subscriptionJs.BEARER.Stripe.Debit:
                    if (availablePaymentMethods.Stripe)
                        return true;
                    break;
                case subscriptionJs.BEARER.Heidelpay.Debit:
                case subscriptionJs.BEARER.Heidelpay.CreditCard:
                case subscriptionJs.BEARER.Unzer.Debit:
                case subscriptionJs.BEARER.Unzer.CreditCard:
                    if (getUnzerPaymentMethodSettings(availablePaymentMethods))
                        return true;
                    break;
                case subscriptionJs.BEARER.SlimPay.Debit:
                case subscriptionJs.BEARER.SlimPay.CreditCard:
                    if (availablePaymentMethods.SlimPay)
                        return true;
                    break;
                case subscriptionJs.BEARER.GoCardless.Debit:
                case subscriptionJs.BEARER.GoCardless.Betalingsservice:
                    if (availablePaymentMethods.GoCardless)
                        return true;
                    break;
                case subscriptionJs.BEARER.WirecardElastic.Debit:
                    if (availablePaymentMethods.WirecardElastic)
                        return true;
                    break;
                case subscriptionJs.BEARER.WirecardElastic.CreditCard:
                    if (availablePaymentMethods.WirecardElastic &&
                        (availablePaymentMethods.WirecardElastic.HostedPay || availablePaymentMethods.WirecardElastic.SeamlessPay))
                        return true;
                    break;
                case subscriptionJs.BEARER.Adyen.CreditCard:
                case subscriptionJs.BEARER.Adyen.Debit:
                case subscriptionJs.BEARER.Adyen.iDEAL:
                    if (availablePaymentMethods.Adyen)
                        return true;
                    break;
                case subscriptionJs.BEARER.Worldline.CreditCard:
                    if (availablePaymentMethods.Worldline) {
                        return true;
                    }
                    break;
                case subscriptionJs.BEARER.Worldpay.CreditCard:
                case subscriptionJs.BEARER.Worldpay.Debit:
                    if (availablePaymentMethods.Worldpay) {
                        return true;
                    }
                    break;
                case subscriptionJs.BEARER.MobilePay.MobilePay:
                case subscriptionJs.BEARER.MobilePay.BlackLabel:
                    if (availablePaymentMethods.MobilePay)
                        return true;
                    break;
                case subscriptionJs.BEARER.NetsEasy.CreditCard:
                    if (availablePaymentMethods.NetsEasy) {
                        return true;
                    }
                    break;
                case subscriptionJs.BEARER.PayEx.CreditCard:
                    if (availablePaymentMethods.PayEx) {
                        return true;
                    }
                    break;
                case subscriptionJs.BEARER.PayExInvoiceService.Autogiro:
                case subscriptionJs.BEARER.PayExInvoiceService.Avtalegiro:
                case subscriptionJs.BEARER.PayExInvoiceService.Betalingsservice:
                    if (availablePaymentMethods.PayExInvoiceService)
                        return true;
                    break;
                case subscriptionJs.BEARER.FarPay.Betalingsservice:
                    if (availablePaymentMethods.FarPay) {
                        return true;
                    }
                    break;
                case subscriptionJs.BEARER.Mollie.Debit:
                case subscriptionJs.BEARER.Mollie.CreditCard:
                    if (availablePaymentMethods.Mollie) {
                        return true;
                    }
                    break;
                case subscriptionJs.BEARER.AmazonPay.AmazonPay:
                case subscriptionJs.BEARER.AmazonPay.BlackLabel:
                    if (availablePaymentMethods.AmazonPay)
                        return true;
                    break;
                case subscriptionJs.BEARER.Reepay.CreditCard:
                    if (availablePaymentMethods.Reepay) {
                        return true;
                    }
                    break;
                case subscriptionJs.BEARER.SepaXml.Debit:
                    if (availablePaymentMethods.SepaXml) {
                        return true;
                    }
                    break;                    
                default:
                    throw new SubscriptionError("Unknown payment bearer '" + bearer + "'!");
            }
            return false;
        }

        function getDefaultPreauth(bearer) {
            switch (bearer) {
                case subscriptionJs.BEARER.PayOne.Debit:
                    return availablePaymentMethods.PayOne.DefaultPreauthAmount['Debit'];
                case subscriptionJs.BEARER.PayOne.CreditCard:
                    return availablePaymentMethods.PayOne.DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.PayOne.OnAccount:
                    return availablePaymentMethods.PayOne.DefaultPreauthAmount['OnAccount'];
                case subscriptionJs.BEARER.PayPal.PayPal:
                case subscriptionJs.BEARER.PayPal.BlackLabel:
                    return availablePaymentMethods.PayPal.DefaultPreauthAmount['BlackLabel'];
                case subscriptionJs.BEARER.None.None:
                    return 1;
                case subscriptionJs.BEARER.FakePSP.FakePSP:
                case subscriptionJs.BEARER.FakePSP.BlackLabel:
                    return availablePaymentMethods.FakePSP.DefaultPreauthAmount['BlackLabel'];
                case subscriptionJs.BEARER.FakePSP.Debit:
                    return availablePaymentMethods.FakePSP.DefaultPreauthAmount['Debit'];
                case subscriptionJs.BEARER.FakePSP.CreditCard:
                    return availablePaymentMethods.FakePSP.DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.InvoicePayment.InvoicePayment:
                case subscriptionJs.BEARER.InvoicePayment.BlackLabel:
                    return availablePaymentMethods.InvoicePayment.DefaultPreauthAmount['BlackLabel'];
                case subscriptionJs.BEARER.Wirecard.Debit:
                    return availablePaymentMethods.Wirecard.DefaultPreauthAmount['Debit'];
                case subscriptionJs.BEARER.Wirecard.CreditCard:
                    return availablePaymentMethods.Wirecard.DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.Stripe.CreditCard:
                    return availablePaymentMethods.Stripe.DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.Stripe.Debit:
                    return availablePaymentMethods.Stripe.DefaultPreauthAmount['Debit'];
                case subscriptionJs.BEARER.Heidelpay.Debit:
                case subscriptionJs.BEARER.Unzer.Debit:
                    return getUnzerPaymentMethodSettings(availablePaymentMethods).DefaultPreauthAmount['Debit'];
                case subscriptionJs.BEARER.Heidelpay.CreditCard:
                case subscriptionJs.BEARER.Unzer.CreditCard:
                    return getUnzerPaymentMethodSettings(availablePaymentMethods).DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.SlimPay.Debit:
                    return availablePaymentMethods.SlimPay.DefaultPreauthAmount['Debit'];
                case subscriptionJs.BEARER.SlimPay.CreditCard:
                    return availablePaymentMethods.SlimPay.DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.GoCardless.Debit:
                    return availablePaymentMethods.GoCardless.DefaultPreauthAmount['Debit'];
                case subscriptionJs.BEARER.GoCardless.Betalingsservice:
                    return availablePaymentMethods.GoCardless.DefaultPreauthAmount['Betalingsservice'];
                case subscriptionJs.BEARER.WirecardElastic.Debit:
                    return availablePaymentMethods.WirecardElastic.DefaultPreauthAmount['Debit'];
                case subscriptionJs.BEARER.WirecardElastic.CreditCard:
                    return availablePaymentMethods.WirecardElastic.DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.Adyen.Debit:
                    return availablePaymentMethods.Adyen.DefaultPreauthAmount['Debit'];
                case subscriptionJs.BEARER.Adyen.CreditCard:
                    return availablePaymentMethods.Adyen.DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.Adyen.iDEAL:
                    return availablePaymentMethods.Adyen.DefaultPreauthAmount['iDEAL'];
                case subscriptionJs.BEARER.Worldline.CreditCard:
                    return availablePaymentMethods.Worldline.DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.Worldpay.Debit:
                    return availablePaymentMethods.Worldpay.DefaultPreauthAmount['Debit'];
                case subscriptionJs.BEARER.Worldpay.CreditCard:
                    return availablePaymentMethods.Worldpay.DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.MobilePay.MobilePay:
                case subscriptionJs.BEARER.MobilePay.BlackLabel:
                    return availablePaymentMethods.MobilePay.DefaultPreauthAmount['BlackLabel'];
                case subscriptionJs.BEARER.NetsEasy.CreditCard:
                    return availablePaymentMethods.NetsEasy.DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.PayEx.CreditCard:
                    return availablePaymentMethods.PayEx.DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.PayExInvoiceService.Autogiro:
                    return availablePaymentMethods.PayExInvoiceService.DefaultPreauthAmount['Autogiro'];
                case subscriptionJs.BEARER.PayExInvoiceService.Avtalegiro:
                    return availablePaymentMethods.PayExInvoiceService.DefaultPreauthAmount['Avtalegiro'];
                case subscriptionJs.BEARER.PayExInvoiceService.Betalingsservice:
                    return availablePaymentMethods.PayExInvoiceService.DefaultPreauthAmount['Betalingsservice'];
                case subscriptionJs.BEARER.FarPay.Betalingsservice:
                    return availablePaymentMethods.FarPay.DefaultPreauthAmount['Betalingsservice'];
                case subscriptionJs.BEARER.Mollie.Debit:
                    return availablePaymentMethods.Mollie.DefaultPreauthAmount['Debit'];
                case subscriptionJs.BEARER.Mollie.CreditCard:
                    return availablePaymentMethods.Mollie.DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.AmazonPay.AmazonPay:
                case subscriptionJs.BEARER.AmazonPay.BlackLabel:
                    return availablePaymentMethods.AmazonPay.DefaultPreauthAmount['BlackLabel'];
                case subscriptionJs.BEARER.Reepay.CreditCard:
                    return availablePaymentMethods.Reepay.DefaultPreauthAmount['CreditCard'];
                case subscriptionJs.BEARER.SepaXml.Debit:
                    return availablePaymentMethods.SepaXml.DefaultPreauthAmount['Debit'];
                default:
                    throw new SubscriptionError("Unknown payment bearer '" + bearer + "'!");
            }
        }
        
        function getUnzerPaymentMethodSettings(availablePaymentMethods){
            if(availablePaymentMethods.Unzer){
                return availablePaymentMethods.Unzer;
            }
            else if(availablePaymentMethods.Heidelpay){
                return availablePaymentMethods.Heidelpay;
            }
            else {
                return null;
            }
        }
    };

    // Validates VAT ID syntax, returns true for valid VAT IDs
    subscriptionJs.validateVatId = function (vatId) {
        var countryName = vatId.substring(0, 2).toUpperCase();

        var regex = VAT_ID_REGEX[countryName];
        var result = regex && regex.test(vatId) === true;
        return result;
    };

    // Finalizes a payment after a redirect from a PSP (e.g. for PayPal). We're simply sending the
    // current URL to the server and the server will extract the payment transaction id (or provider
    // transaction id, or whatever identifier we have) to finish the actual payment. This method returns
    // immediately.
    subscriptionJs.finalize = function (success, error) {
        if (!success)
            throw new SubscriptionError("ArgumentMissing: success");
        if (!error)
            throw new SubscriptionError("ArgumentMissing: error");

        post(subscriptionJs.apiUrl + "CustomerSelfService/Finalize",
            { returnUrl: location.href },
            success, error);
    };

    subscriptionJs.selfServiceSettings = function (publicApiKey, locale, success, error) {
        if (!success)
            throw new SubscriptionError("ArgumentMissing: success");
        if (!error)
            throw new SubscriptionError("ArgumentMissing: error");

        get(subscriptionJs.apiUrl + "CustomerSelfService/selfServiceSettings", { entityId: publicApiKey, locale: (locale || 'de') },
            function (data) {
                callAsync(success, data);
            }, error);
    };

    subscriptionJs.createElement = function (type, container, config, style, errorCallback) {
        if (!container)
            throw new SubscriptionError("ArgumentMissing: container");
        if (!config)
            throw new SubscriptionError("ArgumentMissing: config");
        if (!config.publicApiKey)
            throw new SubscriptionError("ArgumentMissing: config.publicApiKey");
        if (!errorCallback)
            throw new SubscriptionError("ArgumentMissing: errorCallback");
        if (!config.locale)
            config.locale = 'en';
        if (!/^[A-Fa-f0-9]{24}$/.test(config.publicApiKey))
            throw new SubscriptionError("PublicApiKey cannot be read!");

        if (type === "paymentForm") {
            return new subscriptionJs.PaymentFormElement(container, config, style, errorCallback);
        }
        else
            throw new SubscriptionError("ArgumentInvalid: type " + type + " not supported!");
    };

    //ELEMENTS
    subscriptionJs.PaymentFormElement = function (container, config, style, errorCallback) {
        var socket;
        var paymentReady = false;
        var tetheredPaymentInformationReady = false;
        var customerDataCache;
        var tetherPaymentInformation;
        var finalTetherPaymentInformation;
        var isFinalTetherPaymentInformationCallRequiredCache = null;//initialized after tetheredPaymentData message received
        var paymentProcessingInprogress = false;

        var sendMessageToIframe = function (msg) {
            if (socket) {
                //console.log(new Date().toISOString() + ":->Message to iframe sent, type=" + msg.type);
                socket.postMessage(JSON.stringify(msg));
            }
            else
                console.log(new Date().toISOString() + ":->Message to iframe is NOT sent, type=" + msg.type);

        };

        var sendCustomerDataToForm = function (newPayerData) {
            customerDataCache = newPayerData;
            var message = { type: subscriptionJs.IFRAME_MSG_TYPES.IN.PayerDataChanged, customerData: newPayerData };
            sendMessageToIframe(message);
        };

        this.payerDataChanged = function (newPayerData) {
            sendCustomerDataToForm(newPayerData);
        };      
        

        var f = function () {
            if (typeof easyXDM !== 'object')
                throw new SubscriptionError('Error initialization easyXDM!');

            socket = new easyXDM.Socket({
                remote: subscriptionJs.selfServiceUrl + "portal/elements/paymentDataForm.html#/" + config.publicApiKey + "?language=" + config.locale,
                container: container,
                onMessage: function (message) {
                    var msg = JSON.parse(message);
                    //console.log(new Date().toISOString()+":<-Message from iframe received , type=" + msg.type);
                    if (msg.type === subscriptionJs.IFRAME_MSG_TYPES.OUT.Resize)
                        container.getElementsByTagName("iframe")[0].style.height = msg.height + "px";
                    else if (msg.type === subscriptionJs.IFRAME_MSG_TYPES.OUT.ConfigLoaded) {
                        sendMessageToIframe(
                            {
                                type: subscriptionJs.IFRAME_MSG_TYPES.IN.PaymentSettings,
                                settings: config,
                                style: style
                            });
                    }
                    else if (msg.type === subscriptionJs.IFRAME_MSG_TYPES.OUT.PaymentReady) {
                        paymentReady = true;
                        if (customerDataCache)
                            sendCustomerDataToForm(customerDataCache);
                    }
                    else if (msg.type === subscriptionJs.IFRAME_MSG_TYPES.OUT.TetheredPaymentData) {
                        processTetheredPaymentData(msg.tetheredPaymentData, msg.isFinalTetherPaymentInformationCallRequired);
                    }
                    else if (msg.type === subscriptionJs.IFRAME_MSG_TYPES.OUT.FinalTetheredPaymentData) {
                        processFinalTetheredPaymentData(msg.finalTetheredPaymentData);
                    }
                    else if (msg.type === subscriptionJs.IFRAME_MSG_TYPES.OUT.Error) {
                        handleError(msg.errorMessageType, msg.errorMessage, msg.errorData);
                    }
                    else if (msg.type === subscriptionJs.IFRAME_MSG_TYPES.OUT.UnloadPaymentForm) {
                        if (msg.finalizationUrl)
                            top.location = msg.finalizationUrl;
                    } else if (msg.type === subscriptionJs.IFRAME_MSG_TYPES.OUT.ProcessPaymentOutsideTheIFrame) {
                        if (msg.wirecardElasticPaymentMethod != null) {
                            bindReady(function () {
                                var scriptLoadedFunction = function () {
                                    var errorCallback = function (errorData) {
                                        handleError(subscriptionJs.IFRAME_MSG_TYPES.IN.FinalTetherPaymentInformation,
                                            errorData.errorMessage, errorData.errorData)
                                    };
                                    if (msg.amount === null) {
                                        msg.amount = msg.wirecardElasticPaymentMethod.DefaultPreauthAmount['CreditCard'];
                                    }                                        
                                    payWirecardElastic(msg.wirecardElasticPaymentMethod, msg.serverData, msg.amount,
                                        msg.currency, msg.paymentData, processFinalTetheredPaymentData, errorCallback);
                                }
                                loadWirecardElasticLibrary(msg.wirecardElasticPaymentMethod, scriptLoadedFunction);
                            });
                        } else if (msg.serverData && msg.serverData.Url) {
                            postRedirect(msg.serverData.Data, msg.serverData.Url, "hidden");
                        } 
                    }
                }
            });
        };

        if (typeof easyXDM === "undefined") {
            bindReady(function () {
                console.log("Start loading easyXDM script");
                loadScript(subscriptionJs.selfServiceUrl + "portal/lib/easyXDM.js", f);
            });
        } else f();
     
        var sendTetherPaymentInformationMsg = function (amount, currency, success, error, msgType) {
            if (!paymentReady)
                throw new SubscriptionError('Payment Form is not ready!');
            if (paymentProcessingInprogress)
                throw new SubscriptionError('Payment processing is in progress!');
            paymentProcessingInprogress = true;
            tetherPaymentInformation = {
                success: success,
                error: error
            };
            var message = {
                type: msgType,
                amount: amount,
                currency: currency
            };
            sendMessageToIframe(message);
        };

        var handleError = function (errorMessageType, errorMessage, errorData) {
            var errorFnCallback;
            if (errorMessageType === subscriptionJs.IFRAME_MSG_TYPES.IN.TetherPaymentInformation || errorMessageType === subscriptionJs.IFRAME_MSG_TYPES.IN.TetherPaymentInformation2)
                errorFnCallback = tetherPaymentInformation.error;
            else if (errorMessageType === subscriptionJs.IFRAME_MSG_TYPES.IN.FinalTetherPaymentInformation)
                errorFnCallback = finalTetherPaymentInformation.error;
            else
                errorFnCallback = errorCallback;
            paymentProcessingInprogress = false;
            callAsync(errorFnCallback,
                {
                    errorMessage: errorMessage,
                    errorData: errorData
                });
        }
        
        var processTetheredPaymentData = function (tetheredPaymentData, isFinalTetherCallRequired) {
            if (!tetherPaymentInformation)
                throw new SubscriptionError("Payment object was not initialized!");
            if (!tetherPaymentInformation.success)
                throw new SubscriptionError("Payment object success method was not initialized!");
            if (!tetheredPaymentData)
                throw new SubscriptionError("TetheredPaymentData is missing!");
            tetheredPaymentInformationReady = true;
            paymentProcessingInprogress = false;
            isFinalTetherPaymentInformationCallRequiredCache = isFinalTetherCallRequired;
            callAsync(tetherPaymentInformation.success, tetheredPaymentData);
        }

        var processFinalTetheredPaymentData = function (finalTetheredPaymentData) {
            if (!tetherPaymentInformation)
                throw new SubscriptionError("Final Payment object was not initialized!");
            if (!finalTetherPaymentInformation.success)
                throw new SubscriptionError("Final Payment object success method was not initialized!");
            if (!finalTetheredPaymentData)
                throw new SubscriptionError("FinalTetheredPaymentData is missing!");
            paymentProcessingInprogress = false;
            callAsync(finalTetherPaymentInformation.success, finalTetheredPaymentData);
        }

        //use same method signature as at Payment class to replace references
        this.tetherPaymentInformation = function (amount, currency, paymentData, success, error) {
            //paymentData is reference to self
            sendTetherPaymentInformationMsg(amount, currency, success, error, subscriptionJs.IFRAME_MSG_TYPES.IN.TetherPaymentInformation);
        };

        this.finalTetherPaymentInformation = function (serverData, amount, currency, paymentData, success, error) {
            //paymentData is reference to self
            if (!tetheredPaymentInformationReady)
                throw new SubscriptionError('Tethered Payment Information is not ready!');
            finalTetherPaymentInformation = {
                success: success,
                error: error
            };
            var message = {
                type: subscriptionJs.IFRAME_MSG_TYPES.IN.FinalTetherPaymentInformation,
                amount: amount,
                currency: currency,
                serverData: serverData
            };
            paymentProcessingInprogress = true;
            sendMessageToIframe(message);
        };

        this.isFinalTetherPaymentInformationCallRequired = function (paymentData) {
            if (isFinalTetherPaymentInformationCallRequiredCache === null)
                throw new SubscriptionError('IsFinalTetherPaymentInformationCallRequired is not ready!');

            return isFinalTetherPaymentInformationCallRequiredCache;
        };

        this.processPaymentData = function (amount, currency, success, error) {
            sendTetherPaymentInformationMsg(amount, currency, success, error, subscriptionJs.IFRAME_MSG_TYPES.IN.TetherPaymentInformation2);
        };
    };

    // Payment data validators
    subscriptionJs.modifyFieldView = function (fieldName, isValid) {
        let input = document.getElementById(fieldName);
        if (!input) {
            return;
        }
        if (isValid){
            input.classList.remove("ng-invalid");
            input.title = fieldName;
            input.removeAttribute('data-toggle');
        }
        else {
            input.classList.add("ng-invalid");
            input.title = 'Please check your input';
            input.setAttribute('data-toggle', 'tooltip');
        }
    }
    
    subscriptionJs.modifyFieldViewWithScope = function (fieldName, isValid, isDirty) {
        let input = document.getElementById(fieldName);
        if (!input) {
            return;
        }
        if (!isValid && isDirty){
            input.classList.add("ng-invalid");
            input.title = 'Please check your input';
            input.setAttribute('data-toggle', 'tooltip');
        }
        else {
            input.classList.remove("ng-invalid");
            input.title = fieldName;
            input.removeAttribute('data-toggle');
        }
    }

    subscriptionJs.isPANValid = function(pan) {
        let isOnlyDigits = /^\d{10,19}$/.test(pan);

        // https://en.wikipedia.org/wiki/Luhn_algorithm (RUS)
        const checkCardByLuhnAlgorithm = function(value) {
            var nCheck = 0;
            var bEven = false;

            for (var n = value.length - 1; n >= 0; n--) {
                var nDigit = parseInt(value.charAt(n), 10);

                if (bEven && (nDigit *= 2) > 9) {
                    nDigit -= 9;
                }

                nCheck += nDigit;
                bEven = !bEven;
            }
            return (nCheck % 10) === 0;
        }
        return isOnlyDigits && checkCardByLuhnAlgorithm(pan);
    }

    subscriptionJs.isCVCValid = function(cvc) {
        return /^\d{3,4}$/.test(cvc);
    }

    subscriptionJs.getExpiryDate = function(expiryMonth, expiryYear) {
        if (expiryMonth || expiryYear) {
            return expiryMonth + '/' + expiryYear;
        }
        return null;
    }

    subscriptionJs.isCardHasCorrectExpiryDate = function (expiryDate) {
        if (!expiryDate){
            return true;
        }

        let expiryMonth = expiryDate.substr(0, 2);
        let expiryYear = expiryDate.substr(3, 4);
        let currentYear = (new Date()).getFullYear();
        if (currentYear !== parseInt(expiryYear)){
            return true;
        }
        let currentMonth = (new Date()).getMonth();

        return parseInt(expiryMonth) > currentMonth;
    }

    subscriptionJs.isIBANValid = function(ibanValue) {
        let ibanValidator = new IBANValidator();
        return ibanValidator.isValidIBAN(ibanValue);
    }

    subscriptionJs.isNationalNumberIdValid = function(coountryCode, nationalIdNumber) {
        var regex = NATIONAL_ID_NUMBER_REGEX[coountryCode];
        return regex && regex.test(nationalIdNumber) === true;
    }
    
    subscriptionJs.getCountryCodeForPaymentMethod = function(paymentMethod) {
        const Autogiro = "Autogiro:PayExInvoiceService";        
        
        switch (paymentMethod) {
            case Autogiro:
                return "SE";
        }
    }

    //
    // HELPERS / private methods
    //
    function loadWirecardElasticLibrary(wirecardElasticPaymentMethod, success) {
        var url = wirecardElasticPaymentMethod.Environment === 'Live'
            ? 'https://api.wirecard.com/engine/hpp/paymentPageLoader.js'
            : 'https://api-test.wirecard.com/engine/hpp/paymentPageLoader.js';
        bindReady(function () {
            console.log("Start loading WirecardElastic script");
            loadScript(url, success);
        });
    }
    
    function payWirecardElastic(wirecardElasticPaymentMethod, serverData, amount, currency, paymentData, success, error) {
        if (wirecardElasticPaymentMethod.SeamlessPay) {
            paymentWirecardElasticSeamless(serverData, amount, currency, paymentData, wirecardElasticPaymentMethod,
                success, error);
        } else {
            paymentWirecardElastic(serverData, amount, currency, paymentData, wirecardElasticPaymentMethod, success, error);
        }
    }

    function paymentWirecardElastic(serverData, amount, currency, paymentData, wirecardElasticPaymentMethod, successCallback, errorCallback) {

        if (!serverData)
            throw new SubscriptionError("ArgumentError: serverData not specified");

        if (!serverData.Data)
            throw new SubscriptionError("ArgumentError: serverData.Data not specified");

        if (!serverData.Data.request_time_stamp)
            throw new SubscriptionError("ArgumentError: serverData.Data.request_time_stamp not specified");

        if (!serverData.Data.request_id)
            throw new SubscriptionError("ArgumentError: serverData.Data.request_id not specified");

        if (!serverData.Data.redirect_url)
            throw new SubscriptionError("ArgumentError: serverData.Data.redirect_url not specified");

        if (!serverData.Data.request_signature)
            throw new SubscriptionError("ArgumentError: serverData.Data.request_signature not specified");

        if (!WirecardPaymentPage)
            throw new SubscriptionError("WirecardElastic called, but WirecardPaymentPage bridge not loaded!");

        var cardBrand = mapCardType(paymentData.cardNumber, "wirecardElastic", errorCallback);
        var requestData = {
            merchant_account_id: wirecardElasticPaymentMethod.MerchantAccountId,
            request_id: serverData.Data.request_id,
            request_time_stamp: serverData.Data.request_time_stamp,
            payment_method: "creditcard",
            transaction_type: "authorization",
            requested_amount: amount,
            requested_amount_currency: currency,
            locale: 'de',
            redirect_url: serverData.Data.redirect_url,
            ip_address: "127.0.0.1",
            attempt_three_d: wirecardElasticPaymentMethod.Is3DSecureActivated,
            first_name: "",
            last_name: getCardHolderLastName(paymentData.cardHolder),
            card_type: cardBrand,
            account_number: paymentData.cardNumber,
            card_security_code: paymentData.cvc,
            expiration_month: paymentData.expiryMonth,
            expiration_year: paymentData.expiryYear,
            request_signature: serverData.Data.request_signature,
            periodic_type: 'recurring',
            sequence_type: 'first',
            city: serverData.Data.city,
            country: serverData.Data.country,
            street1: serverData.Data.address_line1,
            postal_code: serverData.Data.postal_code,
            email: serverData.Data.email
        };

        WirecardPaymentPage.hostedPay(requestData);
    }

    function paymentWirecardElasticSeamless(serverData, amount, currency, paymentData, wirecardElasticPaymentMethod, successCallback, errorCallback) {
        if (!WirecardPaymentPage)
            throw new SubscriptionError("WirecardElastic called, but WirecardPaymentPage bridge not loaded!");

        var paymentMethod = paymentData.bearer;
        if (paymentMethod !== subscriptionJs.BEARER.WirecardElastic.CreditCard)
            throw new SubscriptionError("WirecardElastic seamless works only for credit cards!");

        var requestData = {
            merchant_account_id: wirecardElasticPaymentMethod.MerchantAccountId,
            request_id: serverData.Data.request_id,
            request_time_stamp: serverData.Data.request_time_stamp,
            payment_method: "creditcard",
            transaction_type: "authorization",
            requested_amount: amount,
            requested_amount_currency: currency,
            locale: 'de',
            redirect_url: serverData.Data.threeDRedirect_url,
            ip_address: "127.0.0.1",
            attempt_three_d: wirecardElasticPaymentMethod.Is3DSecureActivated,
            periodic_type: 'recurring',
            sequence_type: 'first',
            city: serverData.Data.city,
            country: serverData.Data.country,
            address_line1: serverData.Data.address_line1,
            postal_code: serverData.Data.postal_code,
            email: serverData.Data.email,
            request_signature: serverData.Data.request_signature
        };

        bindReady(function () {

            var cardBrand = mapCardType(paymentData.cardNumber, "wirecardElastic", errorCallback);
            requestData.first_name = "";
            requestData.last_name = getCardHolderLastName(paymentData.cardHolder);
            requestData.card_type = cardBrand;
            requestData.account_number = paymentData.cardNumber;
            requestData.card_security_code = paymentData.cvc;
            requestData.expiration_month = paymentData.expiryMonth;
            requestData.expiration_year = paymentData.expiryYear;

            var processSucceededResult = function (data) {
                if (data.acs_url) {
                    var threeDData = {
                        PaReq: htmlEncode(data.pareq),
                        MD: serverData.Data.part_Md + htmlEncode(data.nonce3d),
                        TermUrl: serverData.Data.part_termUrl + data.transaction_id
                    };
                    postRedirect(threeDData, htmlEncode(data.acs_url), "hidden");
                } else {
                    post(serverData.Data.clientSideTransactionResultHandlerUrl, data, successCallback, errorCallback);
                }
            };

            WirecardPaymentPage.seamlessPay({
                requestData: requestData,
                onSuccess: processSucceededResult,
                onError: function (err) {
                    //always should be triggered errorCallback
                    //it's independent from server result
                    post(serverData.Data.clientSideTransactionResultHandlerUrl, err, errorCallback, errorCallback);
                }
            });
        });
    }
    
    function postRedirect(data, url, inputType) {
        var form = document.createElement('form');
        form.method = 'post';
        form.action = url;
        form.style.display = "none";
        for (var k in data) {
            if (data.hasOwnProperty(k)) {
                var input = document.createElement('input');
                input.type = inputType;
                input.name = k;
                input.value = decodeURIComponent(data[k]);
                form.appendChild(input);
            }
        }
        if (document.body) document.body.appendChild(form);
        else document.appendChild(form);
        form.submit();
    }

    function getCardHolderLastName(cardHolder) {
        var lastNameMaxLength = 32;
        return cardHolder.substring(0, lastNameMaxLength);
    }

    function mapCardType(cardNumber, codeType, errorCallback) {
        var iin = [
            {
                type: "MasterCard",
                pattern: /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
                luhn: true,
                cvcLength: [3],
                numLength: [16],
                payOneCode: "M",
                unzerCode: "MASTER",
                wirecardElasticCode: "mastercard"
            },
            {
                type: "Visa",
                pattern: /^4/,
                luhn: true,
                cvcLength: [3],
                numLength: [13, 16],
                payOneCode: "V",
                unzerCode: "VISA",
                wirecardElasticCode: "visa"
            },
            {
                type: "American Express",
                pattern: /^3[47]/,
                luhn: true,
                cvcLength: [3, 4],
                numLength: [15],
                payOneCode: "A",
                unzerCode: "AMEX",
                wirecardElasticCode: "amex"
            },
            {
                type: "Discover",
                pattern: /^(6011|622(1[2-90][6-9]|[2-8]\d{2}|9[0-1]\d|92[0-5])|64[4-9]|65)/,
                luhn: true,
                cvcLength: [3],
                numLength: [16],
                payOneCode: "C",
                unzerCode: "DISCOVERY",
                wirecardElasticCode: "discover"
            },
            // { type: "UnionPay", pattern: /^62/, luhn: false, cvcLength: [3], numLength: [16, 17, 18, 19], payOneCode: "" },
            {
                type: "Diners Club",
                pattern: /^(30[0-5]|36|38)/,
                luhn: true,
                cvcLength: [3],
                numLength: [14],
                payOneCode: "D",
                unzerCode: "DINERS",
                wirecardElasticCode: "diners"
            },
            {
                type: "JCB",
                pattern: /^35([3-8][0-9]|2[8-9])/,
                luhn: true,
                cvcLength: [3],
                numLength: [16],
                payOneCode: "J",
                unzerCode: "JCB",
                wirecardElasticCode: "jcb"
            },
            {
                type: "Maestro",
                pattern: /^(5018|5020|5038|5893|6304|6331|6703|6759|676[1-3]|6799|0604)/,
                luhn: true,
                cvcLength: [0, 3, 4],
                numLength: [12, 13, 14, 15, 16, 17, 18, 19],
                payOneCode: "O",
                unzerCode: "MAESTRO",
                wirecardElasticCode: "maestro"
            }
        ];
        var result = null;
        for (var issuer = 0; issuer < iin.length; issuer++) {
            if (iin[issuer].pattern.test(cardNumber)) {
                result = iin[issuer];
                break;
            }
        }
        if (result) {
            switch (codeType) {
                case "payOne":
                    return result.payOneCode;
                case "unzer":
                    return result.unzerCode;
                case "wirecardElastic":
                    return result.wirecardElasticCode;
                default:
                    throw new SubscriptionError("Unknown codeType '" + codeType + "'!");
            }
        }
        errorCallback(createError(["ValidationError", "InvalidCardNumber"], "Unknown card type or invalid card number"));
    }

    function htmlEncode(text) {
        var tempElement = document.createElement("div");
        tempElement.innerHTML = text;
        return tempElement.innerHTML;
    }

    function validateCustomerName(customerData) {
        return customerData.FirstName && customerData.LastName || customerData.CompanyName || customerData.EmailAddress;
    }

    function validateCustomerData(customerData, error) {
        if (customerData.VatId && !subscriptionJs.validateVatId(customerData.VatId)) {
            callAsync(error, createError(["InvalidVatId"]));
            return false;
        }
        if (!validateCustomerName(customerData)) {
            callAsync(error, createError(["InvalidName"]));
            return false;
        }
        return true;
    }

    // Changes property names to PascalCase if required
    function sanitizeCustomerData(customerData) {
        customerData = transformUpperCase(customerData);
        if (customerData.Address)
            customerData.Address = transformUpperCase(customerData.Address);
        return customerData;
    }

    // transforms obj property names to PascalCase
    function transformUpperCase(obj) {
        for (var property in obj) {
            if (obj.hasOwnProperty(property)) {
                var firstChar = property.charAt(0);
                if (firstChar === firstChar.toLowerCase()) {
                    var newProperty = firstChar.toUpperCase() + property.substr(1);
                    obj[newProperty] = obj[property];
                    delete obj[property];
                }
            }
        }
        return obj;
    }

    function loadScript(src, success, error) {
        var r = false;
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = src;
        s.onload = s.onreadystatechange = function () {
            if (!r && (!this.readyState || this.readyState === 'complete')) {
                r = true;
                success();
            }
        };
        s.onerror = function () {
            if (error) { error() };
        };
        var head = document.getElementsByTagName('head')[0];
        head.appendChild(s);
    }

    function serialize(params, obj, traditional, scope) {
        var array = typeof obj === 'array';
        for (var key in obj) {
            var value = obj[key];

            if (scope) key = traditional ? scope : scope + '[' + (array ? '' : key) + ']';
            // handle data in serializeArray() format
            if (!scope && array) params.add(value.name, value.value);
            // recurse into nested objects
            //else if (traditional ? (typeof(value) === 'array') : (type(value) === 'object'))
            //    serialize(params, value, traditional, key)
            else params.add(key, value);
        }
    }

    function param(obj, traditional) {
        var params = [];
        params.add = function(k, v) { this.push(escape(k) + '=' + escape(v)); };
        serialize(params, obj, traditional);
        return params.join('&').replace('%20', '+');
    }

    function encodeToQuery(data) {
        var q = param(data, true);
        return q;
    }

    function createError(errorCode, errorMessage, details) {
        var error = {
            errorCode: [],
            errorMessage: errorMessage || "An unknown error occurred",
            referenceId: null,
            referenceUrl: null,
            details: details || null
        };

        error.errorCode = error.errorCode.concat(errorCode);
        return error;
    }

    function mapPspError(serverError) {       
        if (serverError.get) {
            var errorcodeint = parseInt(serverError.get('errorcode'));
            console.error("PayOne error code: " + errorcodeint);
            
            for (var i = 0; i < PAYONE_ERROR_MAP.length; i++) {
                var errorcodes = PAYONE_ERROR_MAP[i][0];
                for (j = 0; j < errorcodes.length; j++)
                    if (errorcodeint === parseInt(errorcodes[j])) {
                        if(serverError.get('customermessage')) {
                            return createError([PAYONE_ERROR_MAP[i][1]],serverError.get('customermessage'), errorcodes[i]);
                        }
                        return createError([PAYONE_ERROR_MAP[i][1]], "PayOne bearer check failed", errorcodes[j]);
                    }
            }
            return createError(["UnmappedError"], "PayOne error occurred. See PayOne error code in details", errorcodeint);
        }
        if (serverError.error && serverError.error.code)
            for (var i = 0; i < STRIPE_ERROR_MAP.length; i++)
                if (serverError.error.code == STRIPE_ERROR_MAP[i][0])
                    return createError([STRIPE_ERROR_MAP[i][1]], "Creating Stripe token failed");
        if (Object.prototype.toString.call(serverError) === '[object Array]' && serverError[0].errorCode) {
            var error = serverError[0];
            error.errorCode = error.errorCode.toString();
            if (error.errorCode.startsWith('1'))
                error.errorCode = "xx" + error.errorCode.substr(2, 3);

            for (var i = 0; i < WIRECARD_ERROR_MAP.length; i++)
                if (error.errorCode === WIRECARD_ERROR_MAP[i][0])
                    return createError([WIRECARD_ERROR_MAP[i][1]], error.message);
            if (error.message)
                return createError(["UnmappedError"], error.message);
        }
        if (serverError.status_description_1) {
            return createError(["UnmappedError"], serverError.status_description_1, serverError);
        }
        return createError(["UnmappedError"], "An unknown payment error occurred", serverError);
    }

    // stub. maps an error from a third party such as the pactas server or a psp to an iterojs error descriptor
    function mapError(serverError) {
        return createError(["UnmappedError"], "An unknown error occurred", serverError);
    }

    function mapSubscriptionError(SubscriptionError) {
        return createError([SubscriptionError.Code], SubscriptionError.Message, SubscriptionError.Details);
    }

    function getXMLHttpRequest() {
        if (XMLHttpRequest) {
            return new XMLHttpRequest;
        }
        else {
            try {
                return new ActiveXObject("MSXML2.XMLHTTP.3.0");
            }
            catch (ex) {
                return null;
            }
        }
    }

    function handleResponse(client, success, error) {
        var data = JSON.parse(client.responseText);
        if (data.Error) {
            callAsync(error, mapSubscriptionError(data.Error));
        }
        else if (data.Success)
            callAsync(success, data.Success);
        else
            callAsync(success, data); // For calls returning payload
    }

    function callAsync(callback, data) {
        setTimeout(function () {
            callback(data);
        }, 0);
    }

    function rest(url, method, data, success, error) {
        var serializedData = null;

        var query;
        if (method === "PUT" || method === "POST" || method === "PATCH")
            serializedData = JSON.stringify(data);
        else {
            query = encodeToQuery(data);
            if (query !== "") {
                url = url + "?" + query;
            }
        }

        //Is it cross domain? Required to check this for hosted self service
        //as XDomainRequest does not like to do requests for non xsite requests
        var xdomain = ((location.protocol + "//" + location.host + "/").toLowerCase() !== url.toLowerCase().split('/', 3).join('/'));

        var client = getXMLHttpRequest();
        if (client != null && (!xdomain || 'withCredentials' in client)) {
            client.onreadystatechange = function () {
                if (client.readyState === 4) {
                    if (client.status < 400 && client.status > 0) {
                        handleResponse(client, success, error);
                    } else {
                        if (client.status === 0) {
                            if (client.responseText && client.responseText != null) {
                                handleResponse(client, success, error); 
                            }
                            else {
                                var details = "Url: " + url;
                                if (serializedData !== null)
                                    details += ", Data: " + serializedData;
                                callAsync(error, createError(["IteroServerError"], "Failed to connect to Pactas server or request timed out", details));
                            }
                        }
                        else {
                            var errorResult;
                            try {
                                var obj = JSON.parse(client.responseText);
                                if (obj && obj.Message)
                                    errorResult = createError([obj.Code ? obj.Code : "UnmappedError", client.statusText], obj.Message);
                                else if (obj && obj.Error && obj.Error.Message)
                                    errorResult = createError([obj.Error.Code ? obj.Error.Code : "UnmappedError", client.statusText], obj.Message);
                                else
                                    errorResult = createError(["UnmappedError", client.statusText], client.responseText);
                            }
                            catch (e) {
                                errorResult = createError(["UnmappedError", client.statusText], client.responseText);
                            }
                            callAsync(error, errorResult);
                        }
                    }
                }
            };
            client.open(method, url, true);
            client.setRequestHeader("Content-Type", "text/plain");
            client.send(serializedData);
        }
        else if (XDomainRequest) {
            client = new XDomainRequest();
            client.onload = function () {
                var data = JSON.parse(client.responseText);
                if (data.Success)
                    data = data.Success;
                callAsync(success, data);
            };

            client.onerror = function () {
                if (error) {
                    var errorText;
                    // try to parse as json, ignore if not possible
                    try {
                        errorText = JSON.parse(client.responseText);
                        if (errorText.Error)
                            callAsync(error, mapSubscriptionError(errorText.Error));
                        else
                            callAsync(error, mapError(errorText));
                    } catch (e) { callAsync(error, createError(["UnmappedError"], client.responseText)); };
                }
            };

            //Fix IE9 problem with blank handlers
            client.onprogress = function () { };
            client.ontimeout = function () { };

            if (method === 'PUT') {
                query = encodeToQuery({ "requestMethod": "PUT" });
                if (query !== "") {
                    if (url.indexOf('?') < 0)
                        url = url + "?" + query;
                    else
                        url = url + "&" + query;
                }
                method = "POST";
            }
            else if (method === 'PATCH') {
                query = encodeToQuery({ "requestMethod": "PATCH" });
                if (query !== "") {
                    if (url.indexOf('?') < 0)
                        url = url + "?" + query;
                    else
                        url = url + "&" + query;
                }
                method = "POST";
            }

            client.open(method, url);

            //Wrap in timeout handler for IE9 fix (Source: http://stackoverflow.com/questions/20624476/xdomainrequest-cors-for-xml-causing-access-is-denied-error-in-ie8-ie9)
            setTimeout(function () {
                if (serializedData)
                    client.send(serializedData);
                else
                    client.send();
            });
        }
        else {
            throw new Error("Your browser doesn't support AJAX");
        }
    }

    function post(url, data, success, error) {
        return rest(url, "POST", data, success, error);
    }

    function get(url, data, success, error) {
        return rest(url, "GET", data, success, error);
    }

    function put(url, data, success, error) {
        return rest(url, "PUT", data, success, error);
    }

    function patch(url, data, success, error) {
        return rest(url, "PATCH", data, success, error);
    }

    // http://javascript.info/tutorial/onload-ondomcontentloaded#hacks-for-ie-lt-9
    function bindReady(handler) {
        var called = false;

        function ready() {
            if (called) {
                return;
            }
            called = true;
            handler();
        }

        if (document.readyState !== 'loading') {
            ready();
            return;
        }

        if (document.addEventListener) { // native event
            document.addEventListener("DOMContentLoaded", ready, false);
        } else if (document.attachEvent) {  // IE
            var isFrame = false;
            try {
                isFrame = frameElement !== null;
            } catch (e) { }

            // IE, the document is not inside a frame
            if (document.documentElement.doScroll && !isFrame) {
                function tryScroll() {
                    if (called) return;
                    try {
                        document.documentElement.doScroll("left");
                        ready();
                    } catch (e) {
                        setTimeout(tryScroll, 10);
                    }
                }
                tryScroll();
            }

            // IE, the document is inside a frame
            document.attachEvent("onreadystatechange", function () {
                if (document.readyState === "complete") {
                    ready();
                }
            });
        }

        // Old browsers
        if (addEventListener) {
            addEventListener('load', ready, false);
        }
        else if (attachEvent) {
            attachEvent('onload', ready);
        }
        else {
            var fn = onload;  // very old browser, copy old onload
            onload = function () { // replace by new onload and call the old one
                fn && fn();
                ready();
            };
        }
    }

    function validateIBAN(paymentData, error) {
        //Validate IBAN in case of direct debit
        if (paymentData.bearer.indexOf("Debit") === -1)
            return true;

        var ibanValidator = new IBANValidator();
        if (!ibanValidator.isValidIBAN(paymentData.iban)) {
            callAsync(error, createError(["InvalidIban"], "No valid IBAN"));
            return false;
        }

        return true;
    }

    //IBAN Validation https://github.com/arhs/iban.js/blob/master/iban.js
    function IBANValidator() {

        var A = 'A'.charCodeAt(0),
            Z = 'Z'.charCodeAt(0);

        /**
         * Prepare an IBAN for mod 97 computation by moving the first 4 chars to the end and transforming the letters to
         * numbers (A = 10, B = 11, ..., Z = 35), as specified in ISO13616.
         *
         * @param {string} iban the IBAN
         * @returns {string} the prepared IBAN
         */
        function iso13616Prepare(iban) {
            iban = iban.toUpperCase();
            iban = iban.substr(4) + iban.substr(0, 4);

            return iban.split('').map(function (n) {
                var code = n.charCodeAt(0);
                if (code >= A && code <= Z) {
                    // A = 10, B = 11, ... Z = 35
                    return code - A + 10;
                } else {
                    return n;
                }
            }).join('');
        }

        /**
         * Calculates the MOD 97 10 of the passed IBAN as specified in ISO7064.
         *
         * @param iban
         * @returns {number}
         */
        function iso7064Mod97_10(iban) {
            var remainder = iban,
                block;

            while (remainder.length > 2) {
                block = remainder.slice(0, 9);
                remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
            }

            return parseInt(remainder, 10) % 97;
        }

        /**
         * Parse the BBAN structure used to configure each IBAN Specification and returns a matching regular expression.
         * A structure is composed of blocks of 3 characters (one letter and 2 digits). Each block represents
         * a logical group in the typical representation of the BBAN. For each group, the letter indicates which characters
         * are allowed in this group and the following 2-digits number tells the length of the group.
         *
         * @param {string} structure the structure to parse
         * @returns {RegExp}
         */
        function parseStructure(structure) {
            // split in blocks of 3 chars
            var regex = structure.match(/(.{3})/g).map(function (block) {

                // parse each structure block (1-char + 2-digits)
                var format,
                    pattern = block.slice(0, 1),
                    repeats = parseInt(block.slice(1), 10);

                switch (pattern) {
                    case "A": format = "0-9A-Za-z"; break;
                    case "B": format = "0-9A-Z"; break;
                    case "C": format = "A-Za-z"; break;
                    case "F": format = "0-9"; break;
                    case "L": format = "a-z"; break;
                    case "U": format = "A-Z"; break;
                    case "W": format = "0-9a-z"; break;
                }

                return '([' + format + ']{' + repeats + '})';
            });

            return new RegExp('^' + regex.join('') + '$');
        }

        var NON_ALPHANUM = /[^a-zA-Z0-9]/g,
            EVERY_FOUR_CHARS = /(.{4})(?!$)/g;
        /**
                   *  @param iban
                   * @returns {string}
        */
        function electronicFormat(iban) {
            return iban.replace(NON_ALPHANUM, '').toUpperCase();
        }

        /**
         * Create a new Specification for a valid IBAN number.
         *
         * @param countryCode the code of the country
         * @param length the length of the IBAN
         * @param structure the structure of the underlying BBAN (for validation and formatting)
         * @param example an example valid IBAN
         * @constructor
         */
        function Specification(countryCode, length, structure, example) {
            this.countryCode = countryCode;
            this.length = length;
            this.structure = structure;
            this.example = example;
        }

        //Lazy-loaded regex (parse the structure and construct the regular expression the first time we need it for validation)
        Specification.prototype._regex = function () {
            return this._cachedRegex || (this._cachedRegex = parseStructure(this.structure));
        };

        /**
         * Check if the passed iban is valid according to this specification.
         *
         * @param {string} iban the iban to validate
         * @returns {boolean} true if valid, false otherwise
         */
        Specification.prototype.isValid = function (iban) {
            return this.length === iban.length
                && this.countryCode === iban.slice(0, 2)
                && this._regex().test(iban.slice(4))
                && iso7064Mod97_10(iso13616Prepare(iban)) === 1;
        };

        /**
         * Convert the passed IBAN to a country-specific BBAN.
         *
         * @param {string} iban the IBAN to convert
         * @param {string} separator the separator to use between BBAN blocks
         * @returns {string} the BBAN
         */
        Specification.prototype.toBBAN = function (iban, separator) {
            return this._regex().exec(iban.slice(4)).slice(1).join(separator);
        };

        /**
         * Convert the passed BBAN to an IBAN for this country specification.
         * Please note that <i>"generation of the IBAN shall be the exclusive responsibility of the bank/branch servicing the account"</i>.
         * This method implements the preferred algorithm described in http://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits
         *
         * @param {string} bban the BBAN to convert to IBAN
         * @returns {string} the IBAN
         */
        Specification.prototype.fromBBAN = function (bban) {
            if (!this.isValidBBAN(bban)) {
                throw new Error('Invalid BBAN');
            }

            var remainder = iso7064Mod97_10(iso13616Prepare(this.countryCode + '00' + bban)),
                checkDigit = ('0' + (98 - remainder)).slice(-2);

            return this.countryCode + checkDigit + bban;
        };

        /**
         * Check of the passed BBAN is valid.
         * This function only checks the format of the BBAN (length and matching the letetr/number specs) but does not
         * verify the check digit.
         *
         * @param {string} bban the BBAN to validate
         * @returns {boolean} true if the passed bban is a valid BBAN according to this specification, false otherwise
         */
        Specification.prototype.isValidBBAN = function (bban) {
            return this.length - 4 === bban.length
                && this._regex().test(bban);
        };

        var countries = {};

        function addSpecification(IBAN) {
            countries[IBAN.countryCode] = IBAN;
        }

        addSpecification(new Specification("AD", 24, "F04F04A12", "AD1200012030200359100100"));
        addSpecification(new Specification("AE", 23, "F03F16", "AE070331234567890123456"));
        addSpecification(new Specification("AL", 28, "F08A16", "AL47212110090000000235698741"));
        addSpecification(new Specification("AT", 20, "F05F11", "AT611904300234573201"));
        addSpecification(new Specification("AZ", 28, "U04A20", "AZ21NABZ00000000137010001944"));
        addSpecification(new Specification("BA", 20, "F03F03F08F02", "BA391290079401028494"));
        addSpecification(new Specification("BE", 16, "F03F07F02", "BE68539007547034"));
        addSpecification(new Specification("BG", 22, "U04F04F02A08", "BG80BNBG96611020345678"));
        addSpecification(new Specification("BH", 22, "U04A14", "BH67BMAG00001299123456"));
        addSpecification(new Specification("BR", 29, "F08F05F10U01A01", "BR9700360305000010009795493P1"));
        addSpecification(new Specification("CH", 21, "F05A12", "CH9300762011623852957"));
        addSpecification(new Specification("CR", 22, "F04F14", "CR72012300000171549015"));
        addSpecification(new Specification("CY", 28, "F03F05A16", "CY17002001280000001200527600"));
        addSpecification(new Specification("CZ", 24, "F04F06F10", "CZ6508000000192000145399"));
        addSpecification(new Specification("DE", 22, "F08F10", "DE89370400440532013000"));
        addSpecification(new Specification("DK", 18, "F04F09F01", "DK5000400440116243"));
        addSpecification(new Specification("DO", 28, "U04F20", "DO28BAGR00000001212453611324"));
        addSpecification(new Specification("EE", 20, "F02F02F11F01", "EE382200221020145685"));
        addSpecification(new Specification("ES", 24, "F04F04F01F01F10", "ES9121000418450200051332"));
        addSpecification(new Specification("FI", 18, "F06F07F01", "FI2112345600000785"));
        addSpecification(new Specification("FO", 18, "F04F09F01", "FO6264600001631634"));
        addSpecification(new Specification("FR", 27, "F05F05A11F02", "FR1420041010050500013M02606"));
        addSpecification(new Specification("GB", 22, "U04F06F08", "GB29NWBK60161331926819"));
        addSpecification(new Specification("GE", 22, "U02F16", "GE29NB0000000101904917"));
        addSpecification(new Specification("GI", 23, "U04A15", "GI75NWBK000000007099453"));
        addSpecification(new Specification("GL", 18, "F04F09F01", "GL8964710001000206"));
        addSpecification(new Specification("GR", 27, "F03F04A16", "GR1601101250000000012300695"));
        addSpecification(new Specification("GT", 28, "A04A20", "GT82TRAJ01020000001210029690"));
        addSpecification(new Specification("HR", 21, "F07F10", "HR1210010051863000160"));
        addSpecification(new Specification("HU", 28, "F03F04F01F15F01", "HU42117730161111101800000000"));
        addSpecification(new Specification("IE", 22, "U04F06F08", "IE29AIBK93115212345678"));
        addSpecification(new Specification("IL", 23, "F03F03F13", "IL620108000000099999999"));
        addSpecification(new Specification("IS", 26, "F04F02F06F10", "IS140159260076545510730339"));
        addSpecification(new Specification("IT", 27, "U01F05F05A12", "IT60X0542811101000000123456"));
        addSpecification(new Specification("KW", 30, "U04A22", "KW81CBKU0000000000001234560101"));
        addSpecification(new Specification("KZ", 20, "F03A13", "KZ86125KZT5004100100"));
        addSpecification(new Specification("LB", 28, "F04A20", "LB62099900000001001901229114"));
        addSpecification(new Specification("LC", 32, "U04F24", "LC07HEMM000100010012001200013015"));
        addSpecification(new Specification("LI", 21, "F05A12", "LI21088100002324013AA"));
        addSpecification(new Specification("LT", 20, "F05F11", "LT121000011101001000"));
        addSpecification(new Specification("LU", 20, "F03A13", "LU280019400644750000"));
        addSpecification(new Specification("LV", 21, "U04A13", "LV80BANK0000435195001"));
        addSpecification(new Specification("MC", 27, "F05F05A11F02", "MC5811222000010123456789030"));
        addSpecification(new Specification("MD", 24, "U02A18", "MD24AG000225100013104168"));
        addSpecification(new Specification("ME", 22, "F03F13F02", "ME25505000012345678951"));
        addSpecification(new Specification("MK", 19, "F03A10F02", "MK07250120000058984"));
        addSpecification(new Specification("MR", 27, "F05F05F11F02", "MR1300020001010000123456753"));
        addSpecification(new Specification("MT", 31, "U04F05A18", "MT84MALT011000012345MTLCAST001S"));
        addSpecification(new Specification("MU", 30, "U04F02F02F12F03U03", "MU17BOMM0101101030300200000MUR"));
        addSpecification(new Specification("NL", 18, "U04F10", "NL91ABNA0417164300"));
        addSpecification(new Specification("NO", 15, "F04F06F01", "NO9386011117947"));
        addSpecification(new Specification("PK", 24, "U04A16", "PK36SCBL0000001123456702"));
        addSpecification(new Specification("PL", 28, "F08F16", "PL61109010140000071219812874"));
        addSpecification(new Specification("PS", 29, "U04A21", "PS92PALS000000000400123456702"));
        addSpecification(new Specification("PT", 25, "F04F04F11F02", "PT50000201231234567890154"));
        addSpecification(new Specification("RO", 24, "U04A16", "RO49AAAA1B31007593840000"));
        addSpecification(new Specification("RS", 22, "F03F13F02", "RS35260005601001611379"));
        addSpecification(new Specification("SA", 24, "F02A18", "SA0380000000608010167519"));
        addSpecification(new Specification("SE", 24, "F03F16F01", "SE4550000000058398257466"));
        addSpecification(new Specification("SI", 19, "F05F08F02", "SI56263300012039086"));
        addSpecification(new Specification("SK", 24, "F04F06F10", "SK3112000000198742637541"));
        addSpecification(new Specification("SM", 27, "U01F05F05A12", "SM86U0322509800000000270100"));
        addSpecification(new Specification("ST", 25, "F08F11F02", "ST68000100010051845310112"));
        addSpecification(new Specification("TL", 23, "F03F14F02", "TL380080012345678910157"));
        addSpecification(new Specification("TN", 24, "F02F03F13F02", "TN5910006035183598478831"));
        addSpecification(new Specification("TR", 26, "F05F01A16", "TR330006100519786457841326"));
        addSpecification(new Specification("VG", 24, "U04F16", "VG96VPVG0000012345678901"));
        addSpecification(new Specification("XK", 20, "F04F10F02", "XK051212012345678906"));

        // Angola
        addSpecification(new Specification("AO", 25, "F21", "AO69123456789012345678901"));
        // Burkina
        addSpecification(new Specification("BF", 27, "F23", "BF2312345678901234567890123"));
        // Burundi
        addSpecification(new Specification("BI", 16, "F12", "BI41123456789012"));
        // Benin
        addSpecification(new Specification("BJ", 28, "F24", "BJ39123456789012345678901234"));
        // Ivory
        addSpecification(new Specification("CI", 28, "U01F23", "CI17A12345678901234567890123"));
        // Cameron
        addSpecification(new Specification("CM", 27, "F23", "CM9012345678901234567890123"));
        // Cape Verde
        addSpecification(new Specification("CV", 25, "F21", "CV30123456789012345678901"));
        // Algeria
        addSpecification(new Specification("DZ", 24, "F20", "DZ8612345678901234567890"));
        // Iran
        addSpecification(new Specification("IR", 26, "F22", "IR861234568790123456789012"));
        // Jordan
        addSpecification(new Specification("JO", 30, "A04F22", "JO15AAAA1234567890123456789012"));
        // Madagascar
        addSpecification(new Specification("MG", 27, "F23", "MG1812345678901234567890123"));
        // Mali
        addSpecification(new Specification("ML", 28, "U01F23", "ML15A12345678901234567890123"));
        // Mozambique
        addSpecification(new Specification("MZ", 25, "F21", "MZ25123456789012345678901"));
        // Quatar
        addSpecification(new Specification("QA", 29, "U04A21", "QA30AAAA123456789012345678901"));
        // Senegal
        addSpecification(new Specification("SN", 28, "U01F23", "SN52A12345678901234567890123"));
        // Ukraine
        addSpecification(new Specification("UA", 29, "F25", "UA511234567890123456789012345"));

        /**
         * Utility function to check if a variable is a String.
         *
         * @param v
         * @returns {boolean} true if the passed variable is a String, false otherwise.
         */
        function isString(v) {
            return typeof v === 'string' || v instanceof String;
        }

        this.isValidIBAN = function (iban) {
            if (!isString(iban)) {
                return false;
            }
            iban = electronicFormat(iban);
            var countryStructure = countries[iban.slice(0, 2)];
            return !!countryStructure && countryStructure.isValid(iban);
        };


    }

    isTetheredPaymentData = function (tetheredPaymentData) {
        //{ "bearer": bearer, "selectedPaymentMethod": paymentMethod, "returnUrl": paymentConfig.providerReturnUrl };
        if (!tetheredPaymentData)
            return false;
        if (typeof tetheredPaymentData !== 'object')
            return false;
        if (!tetheredPaymentData.selectedPaymentMethod)
            return false;

        if (!tetheredPaymentData.hasOwnProperty('returnUrl'))
            return false;

        return true;
    };

    return subscriptionJs;

})(false ? window : {});

var BillwerkJS = SubscriptionJS;

var IteroJS = SubscriptionJS;

//add missed functions to String object(<=IE11)
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}

// Array.prototype.map polyfill
// code from https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/map
if (!Array.prototype.map) {
    Array.prototype.map = function (fun /*, thisArg */) {
        "use strict";

        if (this === void 0 || this === null)
            throw new TypeError();

        var t = Object(this);
        var len = t.length >>> 0;
        if (typeof fun !== "function")
            throw new TypeError();

        var res = new Array(len);
        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
        for (var i = 0; i < len; i++) {
            // NOTE: Absolute correctness would demand Object.defineProperty
            //       be used.  But this method is fairly new, and failure is
            //       possible only if Object.prototype or Array.prototype
            //       has a property |i| (very unlikely), so use a less-correct
            //       but more portable alternative.
            if (i in t)
                res[i] = fun.call(thisArg, t[i], i, t);
        }

        return res;
    };
}

export { SubscriptionJS };
